export const prefectures = [
  '北海道',
  '青森県',
  '岩手県',
  '宮城県',
  '秋田県',
  '山形県',
  '福島県',
  '茨城県',
  '栃木県',
  '群馬県',
  '埼玉県',
  '千葉県',
  '東京都',
  '神奈川県',
  '新潟県',
  '富山県',
  '石川県',
  '福井県',
  '山梨県',
  '長野県',
  '岐阜県',
  '静岡県',
  '愛知県',
  '三重県',
  '滋賀県',
  '京都府',
  '大阪府',
  '兵庫県',
  '奈良県',
  '和歌山県',
  '鳥取県',
  '島根県',
  '岡山県',
  '広島県',
  '山口県',
  '徳島県',
  '香川県',
  '愛媛県',
  '高知県',
  '福岡県',
  '佐賀県',
  '長崎県',
  '熊本県',
  '大分県',
  '宮崎県',
  '鹿児島県',
  '沖縄県',
]

export const testOrganizations = [
  {
    AutoId: 1,
    Name: 'イーガブ2事務所',
    NameKana: 'イーガブニジムショ',
    PostCode: '100-0001',
    Address: '東京都千代田区千代田1-1-1',
    AddressKana: 'トウキョウトチヨダクチヨダ1-1-1',
    Kenpos: [
      {
        label: 'TJK',
        value: 'o00100_TJK',
      },
      {
        label: 'IT',
        value: 'o00200_IT',
      },
      {
        label: '歯科',
        value: 'o00300_歯科',
      },
      {
        label: '通信',
        value: 'o00400_通信',
      },
      {
        label: '製本',
        value: 'o00500_製本',
      },
      {
        label: '織物',
        value: 'o00600_織物',
      },
      {
        label: '不動産',
        value: 'o00700_不動産',
      },
      {
        label: '医業',
        value: 'o00800_医業',
      },
    ],
    UserMax: 100,
    CompanyMax: 50,
    TodoMax: 1000,
    CheckListMax: 500,
    NoticeMailDays: 'subsidy:3,electronicApplication:7,article36Agreement:14',
  },
  {
    AutoId: 2,
    Name: '__admin__',
  },
]

export const testAppData = {
  AutoId: 11,
  Uid: 'test',
  Admin: true,
  Manager: true,
  Name: 'テスト　太郎',
  NameKana: 'テスト　タロウ',
  ShortName: 'テスト',
  Organization: 'イーガブ2事務所',
  OrgId: 1,
  OrgInfo: {
    Name: 'イーガブ2事務所',
    NameKana: 'イーガブツージムショtest',
    PostCode: '271-8588',
    Address: '千葉県松戸市根本３８７',
    AddressKana: 'チバケンマツドシネモト３８７',
  },
  Organizations: [
    {
      AutoId: 1,
      Name: 'イーガブ2事務所',
    },
    {
      AutoId: 2,
      Name: '__admin__',
    },
  ],
  UserMax: 10,
  CompanyMax: 300,
  TodoMax: 1000,
  CheckListMax: 1000,
  ExtraData: {
    Kenpos: [
      {
        label: 'TJK',
        value: 'o00100_TJK',
      },
      {
        label: 'IT',
        value: 'o00200_IT',
      },
      {
        label: '歯科',
        value: 'o00300_歯科',
      },
      {
        label: '通信',
        value: 'o00400_通信',
      },
      {
        label: '製本',
        value: 'o00500_製本',
      },
      {
        label: '織物',
        value: 'o00600_織物',
      },
      {
        label: '不動産',
        value: 'o00700_不動産',
      },
      {
        label: '医業',
        value: 'o00800_医業',
      },
    ],
  },
  Department: '',
  DepartmentKana: '',
  Title: '',
  PhoneNumber: '090-1111-1111',
  FaxNumber: '',
  MailAddress: 'test@test.com',
  CheckListInfo: {},
  NoticeMailCondition: 'electronicApplication;subsidy;article36Agreement',
  InitPasswdChanged: true,
  OtpEnable: false,
  Passkeys: [],
  PasskeyId: 0,
  PasswdDisable: false,
  LoginFailureLockEnable: true,
  IsLocked: false,
  TosAgreeVersion: 1,
  List: [
    {
      index: 0,
      name: 'login_failure_lock_max',
      label: 'ログイン失敗回数-ユーザロック',
      value: 10,
      typ: 'number',
    },
    {
      index: 1,
      name: 'login_failure_host_restriction_max',
      label: 'ログイン失敗回数-ホスト遮断',
      value: 30,
      typ: 'number',
    },
    {
      index: 2,
      name: 'tos_text',
      label: '利用規約テキスト',
      value:
        '# DEMO for 社労士利用規約\n\n\n\n## 第1条　定義\n\n本規約において使用する用語の意義は、次の各号に定めるとおりとします。\n\n1. 「本規約」とは、「DEMO for 社労士利用規約」をいいます。\n2. 「本契約」とは、本サービスの利用に関する当社と契約者との間の契約をいいます。\n3. 「その他の規程」とは、ガイドライン、ヘルプ、その他の本規約以外の本サービスに関する規程をいいます。\n4. 「本サービス」とは、社会保険労務士事務所向けチームタスク管理システム「DEMO for 社労士」（その理由を問わずサービスの名称又は内容が変更された場合、当該変更後のサービスを含みます。）をいいます。\n5. 「当社」とは、P&A Works Company株式会社をいいます。\n6. 「契約者」とは、当社との間で本契約を締結して本サービスを利用する者をいいます。\n7. 「申込者」とは、本契約を締結して本サービスを利用することを希望する者をいいます。\n8. 「利用者」とは、本規約に基づき契約者から本サービスの利用を認められた契約者の業務従事者をいいます。\n9. 「ユーザ数」とは、本契約において本サービスを利用できる利用者の数をいいます\n10. 「登録事項」とは、申込者が本契約の申込みの際に登録する当社所定の情報をいいます。\n11. 「ID・パスワード」とは、本サービスを利用するために必要となるID・パスワードをいいます。\n12. 「利用環境」とは、ハードウェア、ソフトウェア、インターネット接続回線、セキュリティの確保等、本サービスの利用に必要な環境をいいます（メールサービスも含むものとします。）。\n13. 「送信情報」とは、契約者が本サービス上に送信した、テキスト、数値、データ、その他当社又はメールサービス事業者所定の情報（これを元に本サービス上で自動生成された情報や処理結果も含みます。）をいいます。\n14. 「知的財産権等」とは、特許権、実用新案権、意匠権、商標権、著作権、不正競争防止法上の権利、その他一切の財産的若しくは人格的権利をいいます。\n\n \n\n## 第2条　適用範囲\n\n1. 本規約は、本契約において当社と契約者とに適用されます。契約者は、本規約の全ての内容に同意した上で、本契約を当社と締結するものとします。\n2. 当社は、別途、その他の規程を定める場合があります。その他の規程は、本規約の一部を構成するものとしますが、本規約とその他の規程の内容が異なる場合は、本規約が優先して適用されます。\n\n \n\n## 第3条　本サービスの利用条件\n\n1. 本サービスの詳細な仕様は、当社が別途定めるものとします。また、当社は、本サービスの仕様の改良、追加、削除等の変更を行うことがあり、契約者は、これを予め承諾します。\n2. 契約者は、本契約の有効期間内に限り、本契約で認められた範囲で、当社の定める方法に従い、本サービスを利用し、また、本サービスが予定している態様にて、自社の業務従事者を利用者として、これを利用させることができます。契約者は、利用者に対し、本規約を遵守させるものとし、利用者による本サービスの利用が、いかなる場合でも自己の利用とみなされることに同意すると共に、かかる利用について、当社に対し、一切の責任を負うものとします。\n3. 当社は、本サービスの遂行を、必要に応じて第三者に委託することができるものとします。\n4. 契約者は、自らの責任と費用において、当社所定の利用環境を整備するものとします。\n5. 当社は、本サービスを利用することで出力・表示されるデータ・フローが正確であるよう、商業上合理的な範囲内で努力しますが、その正確性について保証は行いません。契約者は、本サービスを利用することで出力・表示されるデータ・フローの内容を必ず事前に確認の上、自己の責任に基づいてこれを利用するものとします。\n6. 当社は、次の各号につき、いかなる保証も行うものではありません。さらに、契約者が当社から直接又は間接に、本サービスに関する情報を得た場合であっても、当社は、契約者に対し、本規約において規定されている内容を超えて、いかなる保証も行うものではありません。\n   1. 本サービスの利用に起因して利用環境に不具合や障害が生じないこと\n   2. 本サービスが正確かつ完全であること\n   3. 本サービスが永続的に稼働すること\n   4. 本サービスが契約者の特定の目的に適合し、有用であること\n   5. 本サービスが契約者に適用のある法令、業界団体の内部規則等に適合すること\n\n \n\n## 第4条　オプションサービス\n\n1. 当社は、契約者から別途委託を受けた場合、契約者による本サービスの導入・活用コンサルティング、拡張サポート、その他本サービスの導入・利用支援のオプションサービスを行うものとします。\n2. 前項のオプションサービスの費用、対応日時、対応場所、期間、納期等は、別途定めるものとしますが、その他の契約条件は、本規約に定めるとおりとします。\n3. 契約者が第１項のオプションサービスを通じて取得した助言又は情報は、本規約に明示的な定めのない保証を生じさせるものではありません。\n\n \n\n## 第5条　申込み\n\n1. 申込者は、本規約の内容に同意した上で、当社所定の方法により、本契約締結の申込みを行うものとします。申込者は、登録事項が、全て正確であることを保証します。\n2. 当社は、当社所定の基準により、申込者の申込みの可否を判断し、申込みを認める場合には、その旨及び当社所定の情報を通知します。当該通知に定める契約開始日より、当該契約者と当社との間に、本契約が成立します。\n3. 当社は、申込者が以下のいずれかに該当し又は該当すると当社が判断した場合は、申込者の申込みを認めないことができます。なお、当社は、上記判断に関する理由を開示する義務は負いません。\n   1. 当社所定の方法によらずに登録の申込を行った場合\n   2. 登録事項の全部又は一部につき、虚偽、誤記又は記載漏れがあった場合\n   3. 本規約に違反するおそれがあると当社が判断した場合\n   4. 過去に本規約に違反した者又はその関係者であると当社が判断した場合\n   5. 法人の代表権を有する者の同意を得ていなかった場合\n   6. 本サービスと同種又は類似するサービスを現に提供している場合又は将来提供する予定である場合\n   7. その他当社が登録を妥当でないと判断した場合\n4. 契約者は、登録事項に変更が生じた場合は、直ちに当社所定の方法により、登録事項の変更の手続きを行うものとします。これを怠ったことによって契約者が損害を被ったとしても、当社は一切責任を負わないものとします。\n\n \n\n## 第6条　ID・パスワードの管理\n\n1. 当社は、本契約開始日までに、当社が別途定める方式により、ID・パスワードの発行を受けるものとします。\n2. 契約者は、自己の責任において、ID・パスワードを適切に管理・保管し、また、利用者をして、ID・パスワードを管理・保管させるものとし、これを第三者に開示・利用させたり、貸与、譲渡、売買、担保提供等をしてはならないものとします。\n3. 当社は、ログイン時に使用されたID・パスワードが登録されたものと一致することを所定の方法により確認した場合、当該ログインした者を真正な契約者・利用者とみなします。\n4. 契約者によるID・パスワードの管理不十分、使用上の過誤、不正使用等によって契約者が損害を被ったとしても、当社は一切責任を負わないものとします。\n\n \n\n## 第7条　利用料金及び支払方法\n\n1. 契約者は、当社に対し、本サービス利用の対価として、本契約に定める利用料金を、本契約に定める支払方法に従って、本契約に定める支払期日までに支払うものとします。なお、銀行振込手数料その他支払に要する費用は、契約者の負担とします。\n2. その理由を問わず、本契約の有効期間中に契約者が本サービスの提供を受けられなくなった場合又は受ける必要がなくなった場合でも、当社は利用料金の返還を行うことができません。\n3. 契約者が利用料金の支払を遅延した場合、年１４．６％の割合による遅延損害金を当社に支払うものとします。\n4. 当社は、本サービスの内容の変更、事業上の理由、法令の制定改廃、経済情勢の変動等によって、利用料金の変更の必要が生じたときは、第１８条に従い、利用料金を変更することができるものとします。\n\n \n\n## 第8条　契約期間・更新・解約\n\n1. 本契約の契約期間には、１ヶ月単位の契約と、１年単位の契約があります。以下、1ヶ月単位の契約をビジネスライセンス、１年単位の契約をエンタープライズライセンスといいます。なお、ビジネスライセンスにおける初回の契約期間は、契約開始日が属する月の末日までで１ヶ月と算定し、エンタープライズライセンスにおける初回の契約期間は、契約開始日が属する月の翌月１日から起算して１年間で算定します。同一の契約者において、ビジネスライセンス又はエンタープライズライセンスが併存することはありません。\n2. ビジネスライセンスでは、本契約開始日が属する月の１日から起算して３ヶ月間を最低契約期間とし、当該最低契約期間経過後は、本契約の終了希望月の前月末日までに、当社又は契約者のいずれからも、本契約を更新せずに終了させる旨の通知を行わない限り、１ヶ月毎に自動更新されるものとします。\n3. エンタープライズライセンスでは、本契約の契約期間満了月の前月末日までに、当社又は契約者のいずれからも、本契約を更新せずに終了させる旨の通知を行わない限り、１年毎に自動更新されるものとします。\n4. 当社及び契約者は、本契約の契約期間中といえども、いつでも本契約を解約できるものとします。ただし、契約者が解約を行う場合、ビジネスライセンスでは、解約日が属する月（１ヶ月単位の契約期間としての月を意味します。）の利用料金は日割計算されずに発生するものとし、エンタープライズライセンスの場合は、解約月の翌月から契約期間満了月までの期間に対応する利用料金は発生しないものとします（契約者が既に支払済みの場合、当社はこれを返還するものとします。）。\n\n \n\n## 第9条　ユーザ数\n\n1. ビジネスライセンス及びエンタープライズライセンスでは、当社所定のユーザ数の範囲内であれば、利用料金は同一です。\n2. ビジネスライセンス及びエンタープライズライセンスでは、契約者は、本契約の契約期間中、いつでもユーザ数の追加を申し込むことができます。当社所定のユーザー数を超えるユーザ数を追加した場合の、追加したユーザーに係る利用料金は、追加日の属する月の翌月より発生します（すなわち、追加日の属する月は日割計算せず無料とします。）。\n3. ビジネスライセンス及びエンタープライズライセンスでは、契約者は、本契約の契約期間中、いつでもユーザ数の削減を申し込むことができます。当社所定のユーザー数を超えている場合の、削除したユーザ数に係る利用料金は、削除日の属する月の翌月より消滅します（すなわち、削除日の属する月は日割計算せず有料とします。）。\n\n \n\n## 第10条　権利帰属\n\n1. 本サービスに関する知的財産権等は、全て当社に帰属します。\n2. 本規約に定める本サービスの利用許諾は、本規約に明示的に規定される場合を除き、本サービスに関する当社の知的財産権等に関し、いかなる権利も許諾するものではありません。契約者は、本サービスが予定している利用態様を超えて、本サービスを利用することはできません。\n3. 契約者は、本サービスに対して、リバースエンジニアリング、逆コンパイル、又は逆アセンブラ、その他本サービスを解析しようと試みてはならないものとします。\n\n \n\n## 第11条　送信情報\n\n1. 契約者は、送信情報について、自らが送信することについて適法な権利を有していること及び当社又は第三者の権利を侵害するものではないことを保証します。\n2. 契約者は、送信情報に係る知的財産権等を、送信後も引き続き保有します。当社は、契約者に対して本サービスを提供するために必要かつ合理的な範囲に限って、送信情報を利用することができるものとします。\n3. 当社は、送信情報について、安全に管理するよう努めますが、本サービスが、本質的に情報の喪失、改変、破壊等の危険が内在するインターネット通信網を利用した電磁的サービスであることに鑑みて、契約者は、送信情報を自らの責任においてバックアップするものとします。当該バックアップを怠ったことによって契約者が被った損害について、当社は、送信情報の復旧を含めて、一切責任を負いません。\n4. 当社は、以下のいずれかに該当する場合は、送信情報を削除するものとします。当社は、削除された送信情報について、当該情報の復旧を含めて、一切責任を負いません。\n   1. 契約者の同意を得たとき\n   2. 裁判所、警察等の公的機関から、法令に基づく正式な要請を受けたとき\n   3. 法律に従い削除等の義務を負うとき\n   4. 契約者が本規約所定の禁止行為を行ったとき\n   5. 契約者又は第三者の生命・身体・その他重要な権利を保護するために必要なとき\n   6. その理由を問わず、本契約が終了したとき\n   7. 第１４条によって本サービスが変更、中断、終了したとき\n5. 当社は、送信情報を保存、監視する義務を負わないものとします。\n\n  \n\n## 第12条　禁止行為\n\n契約者は、本サービスの利用にあたり、以下の各号のいずれかに該当し又は該当すると当社が判断する行為をしてはなりません。\n\n1. 法令に違反する行為\n2. 犯罪に関連する行為\n3. 公序良俗に反する行為\n4. 所属する業界団体の内部規則に違反する行為\n5. 当社又は第三者の知的財産権等、プライバシー権、名誉権、信用、肖像権、その他一切の権利又は利益を侵害する行為\n6. 本サービスの運営・維持を妨げる行為\n7. 本サービスのネットワーク又はシステム等に過度の負担をかける行為\n8. 本サービスのネットワークに不正にアクセスする行為\n9. 第三者になりすます行為\n10. 第三者に本サービスを利用させる行為\n11. 違法または不正な方法により取得した送信情報を当社に送信する行為\n12. 本サービスにより利用しうる情報を改ざんする行為\n13. 利用者が前各号の行為を行うことを看過し又は是正しない行為\n14. 前各号の行為を直接又は間接に惹起し又は容易にする行為\n15. その他、当社が不適切と判断する行為\n\n \n\n## 第13条　契約解除等\n\n1. 当社は、契約者が以下の各号のいずれかに該当し又は該当すると当社が判断した場合は、事前に通知することなく、本サービスの全部又は一部の利用の一時停止し又は本契約を解除することができます。なお、当社は、上記判断に関する理由を開示する義務は負いません。\n   1. 本規約のいずれかの条項に違反した場合\n   2. 第５条第３項各号に該当することが判明した場合\n   3. 支払停止若しくは支払不能となり、又は、破産、民事再生手続き開始、会社更生手続開始、特別清算手続開始もしくはこれらに類する手続きの開始の申立てがあった場合\n   4. 自ら振出し、もしくは引受けた手形または小切手につき、不渡りの処分を受けた場合\n   5. 差押、仮差押、仮処分、強制執行または競売の申立てがあった場合\n   6. 租税公課を滞納し、その保全差押を受けた場合\n   7. 解散または営業停止状態となった場合\n   8. 第３乃至第７号の他、契約者の信用状態に重大な変化が生じたと当社が判断した場合\n   9. １２ヶ月以上本サービスの利用がない場合\n   10. 当社からの問い合わせに対して、２０日間以上応答がない場合\n   11. その他、当社が本サービスの利用を適当でないと判断した場合\n2. 契約者は、前項各号のいずれかに該当し、又は、該当すると当社が判断した場合は、当社に対して負っている債務の一切について期限の利益を失い、直ちに当社に対する全ての債務の履行をしなければなりません。\n3. 契約者が第１項に基づく本サービスの利用の一時停止の措置を受けている場合であっても、本契約が継続している限り、契約者は利用料金を支払う義務を負うものとします。\n4. 当社は、本条に基づき当社が行った行為により契約者に生じた損害について、一切の責任を負いません。\n\n \n\n## 第14条　本サービスの変更、中断、終了\n\n1. 当社は、事業上の理由、システムの過負荷・不具合・メンテナンス、法令の制定改廃、天災地変、偶発的事故・停電・通信障害・不正アクセス、その他の事由により、本サービスをいつでも変更、中断、終了することができるものとし、これによって契約者に生じたいかなる損害についても、一切責任を負いません。\n2. 当社は、前項の変更、中断、終了にあたっては、事前に相当期間をもって予告するよう務めます。ただし、緊急やむを得ない場合は、この限りでありません。\n\n \n\n## 第15条　紛争処理及び損害賠償\n\n1. 契約者は、本サービスの利用に関連して当社に損害を与えた場合、当社に対し、その損害を賠償するものとします。\n2. 契約者が、本サービスに関連して第三者からクレームを受け又は第三者との間で紛争が生じた場合、契約者は、直ちにその内容を当社に通知すると共に、契約者の費用と責任において、当該クレーム又は紛争を処理し、その進捗及び結果を当社に報告するものとします。\n3. 当社が、契約者による本サービスの利用に関連して第三者からクレームを受け又は第三者との間で紛争が生じた場合、契約者は、契約者の費用と責任において、当該クレーム又は紛争を処理し、その進捗及び結果を当社に報告すると共に、当社が支払いを余儀なくされた金額その他の損害を賠償するものとします。\n4. 当社は、本サービスの提供に際して、自己の故意又は重過失により契約者に損害を与えた場合についてのみこれを賠償するものとします。本規約における当社の各免責規定は、当社に故意又は重過失が存する場合には適用しません。\n5. 当社が契約者に対して損害賠償義務を負う場合（前項の場合又は法律の適用による場合等）、賠償すべき損害の範囲は、契約者に現実に発生した通常の損害に限る（逸失利益を含む特別の損害は含まない。）ものとし、賠償すべき損害の額は、当該損害発生時までに契約者が当社に現実に支払った利用料金の直近１年間（契約期間が１年間に満たない場合は、当該契約期間）の総額を限度とします。なお、本条は、債務不履行、原状回復義務、不当利得、不法行為その他請求原因を問わず、全ての損害賠償等に適用されるものとします。\n6. 前項に拘らず、契約者の損害が、当社による本サービスの提供の全部又は一部が停止したことにより（以下「提供停止」といいます。）発生した場合は、提供停止の状態が発生した時点から起算して４８時間以上その状態が継続したときに限り、翌月の利用料金から、提供停止に係る時間を時間割で計算（６０分未満の端数は切り捨てとします。）した金額を控除することで、前項の賠償に代えるものとします。\n\n \n\n## 第16条　秘密保持\n\n1. 本条において「開示者」とは、本契約の当事者のうち、秘密情報を開示した者をいい、「受領者」とは、秘密情報を受領した者をいい、「秘密情報」とは、開示者の技術、営業、業務、財務、組織、その他の事項に関する全ての情報の内、情報が提供される媒体（書面、光ディスク、ＵＳＢメモリ及びＣＤ等を含むが、これらに限らないものといます。以下同じ。）又は情報を含む電磁的データ（電子メール、電子ファイルの送信又はアップロード等により開示される場合の電子メール及び電子ファイルを含むが、これらに限られないものとします。以下同じ。）に秘密である旨が明示されている情報をいいます。また、情報が口頭若しくは視覚的方法により開示される場合は、開示時点で秘密である旨が口頭又は視覚的方法により明示され、かつ当該開示の日から１０日以内に、秘密であることが書面又は電子的手段で通知された情報をいいます。ただし、以下のいずれかに該当する情報は、秘密情報には該当しません。\n   1. 開示された時点で公知である情報\n   2. 開示された後に受領者の責めに帰すべき事由なく公知となった情報\n   3. 開示される以前に受領者が正当に保持していた情報\n   4. 秘密情報を使用することなく受領者が独自に取得した情報\n   5. 受領者が権利を有する第三者から適法に取得した情報\n   6. 開示者から秘密保持の必要なき旨書面で確認された情報\n2. 受領者は、善良なる管理者の注意義務をもって、受領した秘密情報の取扱及び保管を行うものとします。\n3. 受領者は、本契約以外の目的で秘密情報を使用してはならないものとします。\n4. 受領者は、本契約のために客観的かつ合理的に必要な範囲に限り、秘密情報の複製を行うことができます。\n5. 受領者は、秘密情報を流出させてはならず、また、開示者の事前の書面による承諾なしに、秘密情報を第三者に開示してはならないものとします。ただし、以下の各号に定める者に限り開示することができます。\n   1. 本契約のために必要最小限の自己の役員及び従業員（ただし、本サービスのために客観的かつ合理的に必要な範囲の秘密情報に限ります。）\n   2. 弁護士、公認会計士等の法律上の守秘義務を負う専門家\n   3. 開示者が事前に書面により承諾した第三者（ただし、当該第三者が本契約における受領者の義務と同等の義務を課すことを条件とします。）\n6. 受領者に対する秘密情報の開示は、開示者による当該秘密情報に関する権利の譲渡又は実施の許諾とはみなされません。\n7. 受領者は、開示者から要求があった場合又は本契約が終了した場合には、開示者の指示に従い、開示者から受領した全ての秘密情報を、速やかに開示者に返還又は抹消するものとします。\n8. 受領者は、万一開示を受けた秘密情報が流出した場合には、直ちに開示者にその詳細を報告し、流出の拡大を防止するために客観的に合理的な措置をとるものとします。当該措置に要する合理的な費用は、受領者の負担とします。ただし、開示者の責めに帰すべき事由による場合は、この限りではありません。\n9. 受領者は、司法機関又は行政機関等から秘密情報の開示を求められたときは、速やかに、その事実を開示者に通知し、開示者から要請がある場合には、その開示範囲を狭めるための努力を尽くした後、秘密情報を開示することができます。開示者が法的救済を求めるときは、合理的範囲内で開示者に協力するものとします。\n\n \n\n## 第17条　個人情報の取扱い\n\n当社は、個人情報を、当社所定の「プライバシーポリシー」に基づき、適切に取り扱うものとします。\n\n \n\n## 第18条　本規約の変更\n\n1. 当社は、以下のいずれかの場合に、本規約をいつでも任意に変更することができます。\n   1. 本規約の変更が、契約者の一般の利益に適合するとき\n   2. 本規約の変更が、本契約を締結した目的に反せず、かつ、変更の必要性、変更後の内容の相当性、変更の内容その他の変更に係る事情に照らして合理的なものであるとき\n2. 当社は、前項による本規約の変更にあたり、本規約の変更の効力発生日の２週間前までに、変更する規定の内容及び変更の効力発生日を、当社が運営するウェブサイト上に掲載又は本サービスで表示する方法により、これを周知します。\n3. 契約者が本規約の変更を同意しない場合、第８条（契約期間・更新・解約）の定めに従い、本契約を解約するものとします。契約者が、変更の効力発生日までに本契約を解約しない場合、本規約の変更に同意したものとみなします。\n\n \n\n## 第19条　連絡\n\n1. 当社から契約者への連絡は、書面の送付、電子メールの送信、または本サービスへの掲載等、当社が適当と判断する手段によって行います。当該連絡が、電子メールの送信又は本サービスへの掲載によって行われる場合は、インターネット上に配信された時点で契約者に到達したものとします。\n2. 契約者から当社への連絡は、当社所定の問合せフォーム宛に行うものとします。当社は、問合せフォーム以外からの問い合わせについては、対応する義務を負いません。\n\n \n\n## 第20条　反社会的勢力との関係排除\n\n1. 本条において「反社会的勢力」とは、次の各号のいずれかに該当する者をいいます。\n   1. 暴力団及びその関係団体又はその構成員\n   2. 暴力、威力又は詐欺的手法を駆使して経済的利益を追求する団体又は個人\n   3. その他、前各号の該当者に準ずる者\n2. 契約者及び当社は、次の各号に定める内容について、表明し、保証するものとします。\n   1. 自らが反社会的勢力に該当せず、かつ将来に渡っても該当しないこと\n   2. 自らが反社会的勢力と不適当な関係を有さず、かつ将来に渡っても不適当な関係を有しないこと\n3. 契約者及び当社は、相手方が前項に違反した場合、相手方に対して、催告なくして、本契約の全部又は一部を解除することができます。\n4. 契約者又は当社が第２項に違反した場合、契約者又は当社は、相手方に対して負っている債務の一切について期限の利益を失い、直ちに相手方に対する全ての債務の履行をしなければなりません。\n5. 契約者及び当社は、本条に基づき自己が行った行為により相手方に生じた損害について、一切責任を負わないものとします。\n\n \n\n## 第21条　契約上の地位の譲渡等\n\n1. 契約者は、当社の事前の書面による承諾なく、本契約上の地位又は本サービスに基づく権利義務につき、第三者に対し、譲渡、移転、担保設定、その他の処分をすることはできないこととします。\n2. 当社は、本サービスに係る事業を第三者に譲渡（通常の事業譲渡のみならず、会社分割その他事業が移転するあらゆる場合を含むものとします。）した場合には、当該事業譲渡に伴い、本契約上の地位又は本サービスに基づく権利義務並びに登録事項、送信情報、個人情報、その他の情報を当該事業譲渡の譲受人に譲渡することができるものとし、契約者は、かかる譲渡に予め同意します。\n\n \n\n## 第22条　完全合意\n\n本規約は、本契約に係る当事者間の完全な合意を構成し、本契約の締結以前に当事者間でなされた本契約に関連する書面、口頭、その他いかなる方法による合意も、本規約に取って代わられます。\n\n \n\n## 第23条　分離可能性\n\n本規約の規定の一部が、法令又は裁判所により違法、無効又は不能であるとされた場合においても、当該規定のその他の部分及び本規約のその他の規定は有効に存続し、また、違法、無効又は不能であるとされた部分については、当該部分の趣旨に最も近い有効な規定を無効な部分と置き換えて適用し、若しくは当該部分の趣旨に最も近い有効な規定となるよう合理的な解釈を加えて適用します。\n\n \n\n## 第24条　準拠法\n\n本規約の準拠法は、日本法とします。\n\n \n\n## 第25条　管轄\n\n本サービスに関連して契約者と当社の間で紛争が生じた場合、東京地方裁判所を第一審の専属的合意管轄裁判所とします。\n\n以上\n\n2022年10月1日　制定',
      typ: 'textarea',
    },
    {
      index: 3,
      name: 'tos_version',
      label: '利用規約更新番号',
      value: 1,
      typ: 'number',
    },
  ],
  Dic: {
    2: {
      AutoId: 2,
      Uid: 'spiadmin',
      Name: 'spiadmin',
      ShortName: 'spiadmin',
      IsActive: true,
    },
    4: {
      AutoId: 4,
      Uid: 'manager',
      Name: '田中　昌',
      ShortName: 'tnk',
      IsActive: true,
    },
    5: {
      AutoId: 5,
      Uid: 'yoshii',
      Name: '吉井千博',
      ShortName: 'よっしー',
      IsActive: true,
    },
    6: {
      AutoId: 6,
      Uid: 'kindaichi',
      Name: '金田一　樹生',
      ShortName: 'ハジメちゃん',
      IsActive: true,
    },
    7: {
      AutoId: 7,
      Uid: 'kainuma',
      Name: '開沼光滋',
      ShortName: 'コージー',
      IsActive: true,
    },
    8: {
      AutoId: 8,
      Uid: 'f-kon',
      Name: '今藤彦',
      ShortName: '',
      IsActive: true,
    },
    9: {
      AutoId: 9,
      Uid: 'd-takahashi',
      Name: '高橋',
      ShortName: '高橋',
      IsActive: true,
    },
    10: {
      AutoId: 10,
      Uid: 'kainuma2',
      Name: 'kainuma2',
      ShortName: '',
      IsActive: true,
    },
    11: {
      AutoId: 11,
      Uid: 'test',
      Name: 'test',
      ShortName: 'test',
      IsActive: false,
    },
    12: {
      AutoId: 12,
      Uid: 'TestUser',
      Name: 'テスト　ユーザー',
      ShortName: 'テスト',
      IsActive: true,
    },
  },
  TodoList: [
    ['todo_flow_name', 'done', 'count'],
    [
      ['coronaStuff', false, 3],
      ['coronaStuff', true, 2],
      ['coronaOthers', true, 1],
      ['mentalStuff', false, 3],
      ['mentalReturn', false, 1],
      ['maternityLeave', false, 1],
    ],
  ],
  CheckList: [
    ['todo_flow_name', 'text', 'all_count', 'notice_count', 'past_count'],
    [
      ['electronicApplication', 'o00100_申請中', '申請中', 3, 1, 2],
      ['electronicApplication', 'o00200_未対応', '未対応', 2, 0, 1],
      ['electronicApplication', 'o00300_確認中', '確認中', 2, 0, 1],
      ['subsidy', 'o00100_【計】作成中', '【計】作成中', 4, 1, 2],
      ['subsidy', 'o00800_完了', '完了', 1, 0, 0],
      ['article36Agreement', '', '', 2, 0, 0],
      ['article36Agreement', 'o00100_完了', '完了', 2, 0, 2],
      ['article36Agreement', 'o00200_申請中', '申請中', 6, 0, 3],
      ['article36Agreement', 'o00300_確認', '確認', 3, 0, 2],
      ['article36Agreement', 'o00400_待ち', '待ち', 26, 0, 11],
    ],
    [['subsidy', '受付中', 1]],
  ],
  Posts: [
    ['2024-05-12', 6, 'いい', 'いいいい'],
    ['2024-05-12', 6, 'あああ', 'ああああ'],
  ],
}

export const testCompanies = [
  {
    AutoId: 1,
    Name: '株式会社ディーモ',
    NameKana: 'カブシキガイシャディーモ',
    Business: '情報通信業',
    Capital: 10000000,
    Employees: 10,
    Officers: 3,
    SettlementTerm: 3,
    StuffList: [
      {
        number: '_none',
        value: '_none',
        label: '匿名/指定しない',
      },
    ],
    StuffNames: '匿名/指定しない',
    CorporateNumber: '1234567890123',
    PostCode: '123-4567',
    Prefecture: '東京都',
    City: '千代田区',
    Address: '千代田1-1-1',
    AddressKana: 'チヨダ1-1-1',
    PhoneNumber: '03-1234-5678',
    FaxNumber: '03-1234-5679',
    MailAddress: 'test@test.jp',
    ApplicantTitle: '代表取締役',
    ApplicantName: '山田太郎',
    ApplicantNameKana: 'ヤマダタロウ',
    ApplicantDepartment: '総務部',
    ApplicantDepartmentKana: 'ソウムブ',
    Version: 1,
  },
  {
    AutoId: 2,
    Name: '株式会社ディーモ2',
    NameKana: 'カブシキガイシャディーモ2',
    Business: '情報通信業',
    Capital: 10000000,
    Employees: 10,
    Officers: 3,
    SettlementTerm: 3,
    StuffList: [
      {
        number: '_none',
        value: '_none',
        label: '匿名/指定しない',
      },
    ],
    StuffNames: '匿名/指定しない',
    CorporateNumber: '1234567890123',
    PostCode: '123-4567',
    Prefecture: '東京都',
    City: '千代田区',
    Address: '千代田1-1-1',
    AddressKana: 'チヨダ1-1-1',
    PhoneNumber: '03-1234-5678',
    FaxNumber: '03-1234-5679',
    MailAddress: 'test2@test.jp',
    ApplicantTitle: '代表取締役',
    ApplicantName: '山田太郎',
    ApplicantNameKana: 'ヤマダタロウ',
    ApplicantDepartment: '総務部',
    ApplicantDepartmentKana: 'ソウムブ',
    Version: 1,
  },
]

export const testTodo = [
  {
    AutoId: 1,
    Done: false,
    Status: '未完了',
    Company: 1,
    Stuff: '_none',
    FlowType: 'coronaStuff',
    FlowVer: 0,
    Version: 1,
    CreateUserId: 1,
    UpdateUserId: 1,
    DoneUserId: null,
    CreatedAt: '2021-08-02T00:00:00',
    UpdatedAt: '2021-08-02T00:00:00',
    DoneAt: null,
    Items: [
      {
        AutoId: 1,
        name: 'start',
        sel: 'start',
        done: false,
        doneUserId: null,
        doneAt: null,
        memo: null,
      },
      {
        AutoId: 2,
        name: 'kyuugyou',
        sel: 'kyuugyou',
        done: false,
        doneUserId: null,
        doneAt: null,
        memo: null,
      },
      {
        AutoId: 3,
        name: 'sentaku',
        sel: 'yuukyuu',
        done: false,
        doneUserId: null,
        doneAt: null,
        memo: null,
      },
      {
        AutoId: 4,
        name: 'yuukyuu',
        sel: 'keika',
        done: false,
        doneUserId: null,
        doneAt: null,
        memo: null,
      },
      {
        AutoId: 5,
        name: 'nashi',
        sel: 'nashi',
        done: false,
        doneUserId: null,
        doneAt: null,
        memo: null,
      },
      {
        AutoId: 6,
        name: 'keika',
        sel: 'kaifuku',
        done: false,
        doneUserId: null,
        doneAt: null,
        memo: null,
      },
      {
        AutoId: 7,
        name: 'kaifuku',
        sel: 'kaifuku',
        done: false,
        doneUserId: null,
        doneAt: null,
        memo: null,
      },
    ],
  },
  {
    AutoId: 2,
    Done: false,
    Status: '未完了',
    Company: 1,
    Stuff: '_none',
    FlowType: 'coronaStuff',
    FlowVer: 0,
    Version: 1,
    CreateUserId: 1,
    UpdateUserId: 1,
    DoneUserId: null,
    CreatedAt: '2021-08-02T00:00:00',
    UpdatedAt: '2021-08-02T00:00:00',
    DoneAt: null,
    Items: [
      {
        AutoId: 1,
        name: 'start',
        sel: 'start',
        done: false,
        doneUserId: null,
        doneAt: null,
        memo: null,
      },
      {
        AutoId: 2,
        name: 'kyuugyou',
        sel: 'kyuugyou',
        done: false,
        doneUserId: null,
        doneAt: null,
        memo: null,
      },
      {
        AutoId: 3,
        name: 'sentaku',
        sel: 'yuukyuu',
        done: false,
        doneUserId: null,
        doneAt: null,
        memo: null,
      },
      {
        AutoId: 4,
        name: 'yuukyuu',
        sel: 'keika',
        done: false,
        doneUserId: null,
        doneAt: null,
        memo: null,
      },
      {
        AutoId: 5,
        name: 'nashi',
        sel: 'nashi',
        done: false,
        doneUserId: null,
        doneAt: null,
        memo: null,
      },
      {
        AutoId: 6,
        name: 'keika',
        sel: 'kaifuku',
        done: false,
        doneUserId: null,
        doneAt: null,
        memo: null,
      },
      {
        AutoId: 7,
        name: 'kaifuku',
        sel: 'kaifuku',
        done: false,
        doneUserId: null,
        doneAt: null,
        memo: null,
      },
    ],
  },
]

export const testElectronicApplicationCheckList = {
  Value: 'ok',
  Conf: {
    name: 'electronicApplication',
    type: 'checkList',
    title: '電子申請',
    columns: [
      {
        lst: [
          {
            label: 'TJK',
            value: 'o00100_TJK',
          },
          {
            label: 'IT',
            value: 'o00200_IT',
          },
          {
            label: '歯科',
            value: 'o00300_歯科',
          },
          {
            label: '通信',
            value: 'o00400_通信',
          },
          {
            label: '製本',
            value: 'o00500_製本',
          },
          {
            label: '織物',
            value: 'o00600_織物',
          },
          {
            label: '不動産',
            value: 'o00700_不動産',
          },
          {
            label: '医業',
            value: 'o00800_医業',
          },
        ],
        typ: 'select',
        name: 'kenpo',
        label: '健保',
        hidden: false,
        lstSrc: 'Kenpos',
      },
      {
        lst: [
          {
            label: 'ダミー会社a',
            value: 'ダミー会社a',
          },
          {
            label: 'ダミー会社b',
            value: 'ダミー会社b',
          },
          {
            label: 'ダミー会社c',
            value: 'ダミー会社c',
          },
        ],
        typ: 'select',
        name: 'company',
        label: '会社',
        hidden: false,
      },
      {
        lst: [
          {
            label: 'ダミー従業員1',
            value: 'ダミー従業員1',
          },
          {
            label: 'ダミー従業員2',
            value: 'ダミー従業員2',
          },
          {
            label: 'ダミー従業員3',
            value: 'ダミー従業員3',
          },
        ],
        typ: 'combobox',
        name: 'stuff',
        label: '対象者',
        hidden: false,
      },
      {
        lst: [
          {
            label: '申請中',
            style: {
              'background-color': '#6d9eeb',
            },
            value: 'o00100_申請中',
          },
          {
            label: '未対応',
            style: {
              'background-color': '#ff9900',
            },
            value: 'o00200_未対応',
          },
          {
            label: '確認中',
            style: {
              'background-color': '#ff0000',
            },
            value: 'o00300_確認中',
          },
          {
            label: '完了',
            style: {
              'background-color': '#666666',
            },
            value: 'o00400_完了',
          },
          {
            label: 'その他',
            style: {
              'background-color': '#ffffff',
            },
            value: 'o00500_その他',
          },
        ],
        typ: 'select',
        name: 'status',
        label: '状況',
        hidden: false,
      },
      {
        typ: 'text',
        name: 'content',
        label: '内容',
        hidden: false,
        textStyle: {
          width: '150px',
        },
      },
      {
        typ: 'date',
        name: 'deadline',
        label: '該当日',
        hidden: false,
      },
      {
        typ: 'date-pair-main',
        name: 'koyou',
        label: '雇用保険',
        short: true,
        hidden: false,
        allMust: true,
        subLabel: '作業',
        showUpdater: true,
        subLabelList: ['作業', '受理'],
      },
      {
        typ: 'date-pair-sub',
        name: 'koyou-sub',
        label: '雇用保険',
        short: true,
        hidden: false,
        allMust: true,
        subLabel: '受理',
        showUpdater: true,
      },
      {
        typ: 'date',
        name: 'tostuff',
        label: '公文書発送日(本人宛）',
        short: true,
        hidden: false,
        showUpdater: true,
      },
      {
        typ: 'date-pair-main',
        name: 'kenkou',
        label: '健康保険',
        short: true,
        hidden: false,
        allMust: true,
        subLabel: '作業',
        showUpdater: true,
        subLabelList: ['作業', '受理'],
      },
      {
        typ: 'date-pair-sub',
        name: 'kenkou-sub',
        label: '健康保険',
        short: true,
        hidden: false,
        allMust: true,
        subLabel: '受理',
        showUpdater: true,
      },
      {
        typ: 'date-pair-main',
        name: 'kousei',
        label: '厚生年金',
        short: true,
        hidden: false,
        allMust: true,
        subLabel: '作業',
        showUpdater: true,
        subLabelList: ['作業', '受理'],
      },
      {
        typ: 'date-pair-sub',
        name: 'kousei-sub',
        label: '厚生年金',
        short: true,
        hidden: false,
        allMust: true,
        subLabel: '受理',
        showUpdater: true,
      },
      {
        typ: 'date-pair-main',
        name: 'fuyou',
        label: '第三号',
        short: true,
        hidden: false,
        allMust: true,
        subLabel: '作業',
        showUpdater: true,
        subLabelList: ['作業', '受理'],
      },
      {
        typ: 'date-pair-sub',
        name: 'fuyou-sub',
        label: '第三号',
        short: true,
        hidden: false,
        allMust: true,
        subLabel: '受理',
        showUpdater: true,
      },
      {
        typ: 'date',
        name: 'juumin',
        label: '住民税異動届出書',
        short: true,
        hidden: false,
        showUpdater: true,
      },
      {
        typ: 'date',
        name: 'gensen',
        label: '源泉徴収票送付確認',
        short: true,
        hidden: false,
        allMust: true,
        showUpdater: true,
      },
      {
        typ: 'date',
        name: 'shikaku',
        label: '資格証明書',
        short: true,
        hidden: false,
        showUpdater: true,
      },
      {
        typ: 'date',
        name: 'tocompany',
        label: '公文書通知（会社宛）',
        short: true,
        hidden: false,
        showUpdater: true,
      },
      {
        typ: 'text',
        name: 'note',
        label: '備考',
        hidden: false,
      },
      {
        typ: 'text',
        name: 'colorInfo',
        label: '色',
        hidden: true,
      },
    ],
    acceptingEn: false,
    completeStatusList: ['o00400_完了'],
  },
  List: [
    {
      AutoId: 47,
      idx: {
        Value: 0,
      },
      Done: {
        Value: false,
      },
      company: {
        Value: 2,
      },
      stuff: {
        Value: '_none',
      },
      status: {
        Value: 'o00300_確認中',
      },
      deadline: {
        Value: '1970-01-11',
      },
      startdate: {
        Value: null,
      },
      FlowType: {
        Value: 'electronicApplication',
      },
      FlowVer: {
        Value: 0,
      },
      Version: {
        Value: 5,
      },
      CreateUserId: {
        Value: 8,
      },
      UpdateUserId: {
        Value: 8,
      },
      DoneUserId: {
        Value: null,
      },
      CreatedAt: {
        Value: '2024-04-18 14:21:15',
      },
      UpdatedAt: {
        Value: '2024-04-18 14:25:14',
      },
      DoneAt: {
        Value: '',
      },
      kenpo: {
        Value: 'o00700_不動産',
        UpdateUserId: 8,
      },
      content: {
        Value: '雇用補助金',
        UpdateUserId: 8,
      },
      koyou: {
        Value: '2024-04-25',
        UpdateUserId: 8,
      },
      'koyou-sub': {
        Value: '',
        UpdateUserId: 8,
      },
      tostuff: {
        Value: '2024-04-26',
        UpdateUserId: 8,
      },
      kenkou: {
        Value: '',
        UpdateUserId: 8,
      },
      'kenkou-sub': {
        Value: '',
        UpdateUserId: 8,
      },
      kousei: {
        Value: '',
        UpdateUserId: 8,
      },
      'kousei-sub': {
        Value: '',
        UpdateUserId: 8,
      },
      fuyou: {
        Value: '',
        UpdateUserId: 8,
      },
      'fuyou-sub': {
        Value: '',
        UpdateUserId: 8,
      },
      juumin: {
        Value: '',
        UpdateUserId: 8,
      },
      gensen: {
        Value: '',
        UpdateUserId: 8,
      },
      shikaku: {
        Value: '',
        UpdateUserId: 8,
      },
      tocompany: {
        Value: '',
        UpdateUserId: 8,
      },
      note: {
        Value: '',
        UpdateUserId: 8,
      },
      colorInfo: {
        Value: ';',
        UpdateUserId: 8,
      },
      Egov: null,
      egovStatus: {
        Value: '',
      },
    },
    {
      AutoId: 45,
      idx: {
        Value: 1,
      },
      Done: {
        Value: false,
      },
      company: {
        Value: 2,
      },
      stuff: {
        Value: '_none',
      },
      status: {
        Value: 'o00100_申請中',
      },
      deadline: {
        Value: '2024-05-31',
      },
      startdate: {
        Value: null,
      },
      FlowType: {
        Value: 'electronicApplication',
      },
      FlowVer: {
        Value: 0,
      },
      Version: {
        Value: 4,
      },
      CreateUserId: {
        Value: 8,
      },
      UpdateUserId: {
        Value: 8,
      },
      DoneUserId: {
        Value: null,
      },
      CreatedAt: {
        Value: '2024-04-18 14:19:35',
      },
      UpdatedAt: {
        Value: '2024-04-18 14:26:20',
      },
      DoneAt: {
        Value: '',
      },
      kenpo: {
        Value: 'o00500_製本',
        UpdateUserId: 8,
      },
      content: {
        Value: '補助金B',
        UpdateUserId: 8,
      },
      koyou: {
        Value: '',
        UpdateUserId: 8,
      },
      'koyou-sub': {
        Value: '',
        UpdateUserId: 8,
      },
      tostuff: {
        Value: '',
        UpdateUserId: 8,
      },
      kenkou: {
        Value: '',
        UpdateUserId: 8,
      },
      'kenkou-sub': {
        Value: '',
        UpdateUserId: 8,
      },
      kousei: {
        Value: '',
        UpdateUserId: 8,
      },
      'kousei-sub': {
        Value: '',
        UpdateUserId: 8,
      },
      fuyou: {
        Value: '2024-03-22',
        UpdateUserId: 8,
      },
      'fuyou-sub': {
        Value: '',
        UpdateUserId: 8,
      },
      juumin: {
        Value: '',
        UpdateUserId: 8,
      },
      gensen: {
        Value: '2024-04-12',
        UpdateUserId: 8,
      },
      shikaku: {
        Value: '',
        UpdateUserId: 8,
      },
      tocompany: {
        Value: '',
        UpdateUserId: 8,
      },
      note: {
        Value: '',
        UpdateUserId: 8,
      },
      colorInfo: {
        Value: ';gensen:r0;',
        UpdateUserId: 8,
      },
      Egov: null,
      egovStatus: {
        Value: '',
      },
    },
    {
      AutoId: 59,
      idx: {
        Value: 2,
      },
      Done: {
        Value: false,
      },
      company: {
        Value: 1,
      },
      stuff: {
        Value: '_none',
      },
      status: {
        Value: 'o00100_申請中',
      },
      deadline: {
        Value: '2024-05-07',
      },
      startdate: {
        Value: null,
      },
      FlowType: {
        Value: 'electronicApplication',
      },
      FlowVer: {
        Value: 0,
      },
      Version: {
        Value: 1,
      },
      CreateUserId: {
        Value: 6,
      },
      UpdateUserId: {
        Value: 6,
      },
      DoneUserId: {
        Value: null,
      },
      CreatedAt: {
        Value: '2024-05-05 15:41:20',
      },
      UpdatedAt: {
        Value: '2024-05-05 15:41:20',
      },
      DoneAt: {
        Value: '',
      },
      kenpo: {
        Value: 'o00100_TJK',
        UpdateUserId: 6,
      },
      content: {
        Value: 'Test',
        UpdateUserId: 6,
      },
      koyou: {
        Value: '2024-05-08',
        UpdateUserId: 6,
      },
      'koyou-sub': {
        Value: '2024-05-16',
        UpdateUserId: 6,
      },
      tostuff: {
        Value: '2024-05-16',
        UpdateUserId: 6,
      },
      kenkou: {
        Value: '2024-05-10',
        UpdateUserId: 6,
      },
      'kenkou-sub': {
        Value: '2024-05-24',
        UpdateUserId: 6,
      },
      kousei: {
        Value: '2024-05-16',
        UpdateUserId: 6,
      },
      'kousei-sub': {
        Value: '2024-05-30',
        UpdateUserId: 6,
      },
      fuyou: {
        Value: '2024-05-10',
        UpdateUserId: 6,
      },
      'fuyou-sub': {
        Value: '2024-05-23',
        UpdateUserId: 6,
      },
      juumin: {
        Value: '2024-05-31',
        UpdateUserId: 6,
      },
      gensen: {
        Value: '2024-05-30',
        UpdateUserId: 6,
      },
      shikaku: {
        Value: '2024-05-30',
        UpdateUserId: 6,
      },
      tocompany: {
        Value: '2024-05-29',
        UpdateUserId: 6,
      },
      note: {
        Value: 'test',
        UpdateUserId: 6,
      },
      colorInfo: {
        Value: ';kenpo:r0;company:r0;stuff:g0;status:b0;',
        UpdateUserId: 6,
      },
      Egov: null,
      egovStatus: {
        Value: '',
      },
    },
    {
      AutoId: 46,
      idx: {
        Value: 3,
      },
      Done: {
        Value: false,
      },
      company: {
        Value: 2,
      },
      stuff: {
        Value: '_none',
      },
      status: {
        Value: 'o00300_確認中',
      },
      deadline: {
        Value: '2024-04-30',
      },
      startdate: {
        Value: null,
      },
      FlowType: {
        Value: 'electronicApplication',
      },
      FlowVer: {
        Value: 0,
      },
      Version: {
        Value: 2,
      },
      CreateUserId: {
        Value: 8,
      },
      UpdateUserId: {
        Value: 8,
      },
      DoneUserId: {
        Value: null,
      },
      CreatedAt: {
        Value: '2024-04-18 14:20:33',
      },
      UpdatedAt: {
        Value: '2024-04-18 14:25:34',
      },
      DoneAt: {
        Value: '',
      },
      kenpo: {
        Value: 'o00700_不動産',
        UpdateUserId: 8,
      },
      content: {
        Value: '教育補助金',
        UpdateUserId: 8,
      },
      koyou: {
        Value: '',
        UpdateUserId: 8,
      },
      'koyou-sub': {
        Value: '',
        UpdateUserId: 8,
      },
      tostuff: {
        Value: '',
        UpdateUserId: 8,
      },
      kenkou: {
        Value: '',
        UpdateUserId: 8,
      },
      'kenkou-sub': {
        Value: '',
        UpdateUserId: 8,
      },
      kousei: {
        Value: '',
        UpdateUserId: 8,
      },
      'kousei-sub': {
        Value: '',
        UpdateUserId: 8,
      },
      fuyou: {
        Value: '',
        UpdateUserId: 8,
      },
      'fuyou-sub': {
        Value: '',
        UpdateUserId: 8,
      },
      juumin: {
        Value: '',
        UpdateUserId: 8,
      },
      gensen: {
        Value: '',
        UpdateUserId: 8,
      },
      shikaku: {
        Value: '',
        UpdateUserId: 8,
      },
      tocompany: {
        Value: '',
        UpdateUserId: 8,
      },
      note: {
        Value: '',
        UpdateUserId: 8,
      },
      colorInfo: {
        Value: ';deadline:g1;',
        UpdateUserId: 8,
      },
      Egov: null,
      egovStatus: {
        Value: '',
      },
    },
    {
      AutoId: 38,
      idx: {
        Value: 4,
      },
      Done: {
        Value: false,
      },
      company: {
        Value: 1,
      },
      stuff: {
        Value: '_none',
      },
      status: {
        Value: 'o00200_未対応',
      },
      deadline: {
        Value: '2024-04-05',
      },
      startdate: {
        Value: null,
      },
      FlowType: {
        Value: 'electronicApplication',
      },
      FlowVer: {
        Value: 0,
      },
      Version: {
        Value: 4,
      },
      CreateUserId: {
        Value: 4,
      },
      UpdateUserId: {
        Value: 8,
      },
      DoneUserId: {
        Value: null,
      },
      CreatedAt: {
        Value: '2024-03-28 18:12:54',
      },
      UpdatedAt: {
        Value: '2024-04-18 14:25:51',
      },
      DoneAt: {
        Value: '',
      },
      kenpo: {
        Value: 'o00100_TJK',
        UpdateUserId: 4,
      },
      content: {
        Value: '健康補助金',
        UpdateUserId: 8,
      },
      koyou: {
        Value: '2024-03-08',
        UpdateUserId: 8,
      },
      'koyou-sub': {
        Value: '',
        UpdateUserId: 4,
      },
      tostuff: {
        Value: '',
        UpdateUserId: 4,
      },
      kenkou: {
        Value: '2024-06-27',
        UpdateUserId: 8,
      },
      'kenkou-sub': {
        Value: '',
        UpdateUserId: 4,
      },
      kousei: {
        Value: '',
        UpdateUserId: 4,
      },
      'kousei-sub': {
        Value: '',
        UpdateUserId: 4,
      },
      fuyou: {
        Value: '',
        UpdateUserId: 4,
      },
      'fuyou-sub': {
        Value: '',
        UpdateUserId: 4,
      },
      juumin: {
        Value: '',
        UpdateUserId: 4,
      },
      gensen: {
        Value: '',
        UpdateUserId: 4,
      },
      shikaku: {
        Value: '',
        UpdateUserId: 4,
      },
      tocompany: {
        Value: '',
        UpdateUserId: 4,
      },
      note: {
        Value: 'ううう',
        UpdateUserId: 4,
      },
      colorInfo: {
        Value: ';',
        UpdateUserId: 4,
      },
      Egov: null,
      egovStatus: {
        Value: '',
      },
    },
    {
      AutoId: 1,
      idx: {
        Value: 5,
      },
      Done: {
        Value: false,
      },
      company: {
        Value: 1,
      },
      stuff: {
        Value: '_none',
      },
      status: {
        Value: 'o00500_その他',
      },
      deadline: {
        Value: '2024-03-14',
      },
      startdate: {
        Value: null,
      },
      FlowType: {
        Value: 'electronicApplication',
      },
      FlowVer: {
        Value: 0,
      },
      Version: {
        Value: 2,
      },
      CreateUserId: {
        Value: 4,
      },
      UpdateUserId: {
        Value: 8,
      },
      DoneUserId: {
        Value: null,
      },
      CreatedAt: {
        Value: '2024-03-06 11:41:56',
      },
      UpdatedAt: {
        Value: '2024-04-18 14:22:47',
      },
      DoneAt: {
        Value: '',
      },
      kenpo: {
        Value: 'o00100_TJK',
        UpdateUserId: 4,
      },
      content: {
        Value: 'テスト',
        UpdateUserId: 4,
      },
      koyou: {
        Value: '',
        UpdateUserId: 4,
      },
      'koyou-sub': {
        Value: '',
        UpdateUserId: 4,
      },
      tostuff: {
        Value: '',
        UpdateUserId: 4,
      },
      kenkou: {
        Value: '',
        UpdateUserId: 4,
      },
      'kenkou-sub': {
        Value: '',
        UpdateUserId: 4,
      },
      kousei: {
        Value: '',
        UpdateUserId: 4,
      },
      'kousei-sub': {
        Value: '',
        UpdateUserId: 4,
      },
      fuyou: {
        Value: '',
        UpdateUserId: 4,
      },
      'fuyou-sub': {
        Value: '',
        UpdateUserId: 4,
      },
      juumin: {
        Value: '',
        UpdateUserId: 4,
      },
      gensen: {
        Value: '',
        UpdateUserId: 4,
      },
      shikaku: {
        Value: '',
        UpdateUserId: 4,
      },
      tocompany: {
        Value: '',
        UpdateUserId: 4,
      },
      note: {
        Value: '',
        UpdateUserId: 4,
      },
      colorInfo: {
        Value: ';',
        UpdateUserId: 4,
      },
      Egov: null,
      egovStatus: {
        Value: '',
      },
    },
  ],
  Count: 6,
  Type: 'getCheckListsRsp',
}

export const testSubsidyCheckList = {
  Value: 'ok',
  Conf: {
    name: 'subsidy',
    type: 'checkList',
    title: '助成金',
    columns: [
      {
        typ: 'text',
        name: 'subsidy',
        label: '助成金種類',
        hidden: false,
      },
      {
        lst: [
          {
            label: 'ダミー会社a',
            value: 'ダミー会社a',
          },
          {
            label: 'ダミー会社b',
            value: 'ダミー会社b',
          },
          {
            label: 'ダミー会社c',
            value: 'ダミー会社c',
          },
        ],
        typ: 'select',
        name: 'company',
        label: '会社',
        hidden: false,
      },
      {
        lst: [
          {
            label: '【計】作成中',
            style: {
              'background-color': '#ffff00',
            },
            value: 'o00100_【計】作成中',
          },
          {
            label: '【計】提出完了',
            style: {
              'background-color': '#b7e1cd',
            },
            value: 'o00200_【計】提出完了',
          },
          {
            label: '【計】不備対応中',
            style: {
              'background-color': '#ff0000',
            },
            value: 'o00300_【計】不備対応中',
          },
          {
            label: '【支】作成中',
            style: {
              'background-color': '#ffff00',
            },
            value: 'o00400_【支】作成中',
          },
          {
            label: '【支】提出完了',
            style: {
              'background-color': '#b7e1cd',
            },
            value: 'o00500_【支】提出完了',
          },
          {
            label: '【支】不備対応中',
            style: {
              'background-color': '#ff0000',
            },
            value: 'o00600_【支】不備対応中',
          },
          {
            label: '計画期間中',
            style: {
              'background-color': '#ffffff',
            },
            value: 'o00700_計画期間中',
          },
          {
            label: '完了',
            style: {
              'background-color': '#666666',
            },
            value: 'o00800_完了',
          },
          {
            label: '確認',
            style: {
              'background-color': '#ff00ff',
            },
            value: 'o00900_確認',
          },
          {
            label: '入金連絡有',
            style: {
              'background-color': '#e06666',
            },
            value: 'o01000_入金連絡有',
          },
        ],
        typ: 'select',
        name: 'status',
        label: '状況',
        hidden: false,
      },
      {
        typ: 'date',
        name: 'startdate',
        label: '申請開始日',
        hidden: false,
      },
      {
        typ: 'date',
        name: 'deadline',
        label: '支給申請期限',
        hidden: false,
      },
      {
        typ: 'date',
        name: 'filingDate',
        label: '提出日、最終更新日',
        hidden: false,
      },
      {
        typ: 'date',
        name: 'paymentStartDate',
        label: '支給開始日',
        hidden: false,
      },
      {
        typ: 'text',
        name: 'persons',
        label: '対象者',
        hidden: false,
      },
      {
        typ: 'date',
        name: 'raiseDate',
        label: '昇給日',
        hidden: false,
      },
      {
        typ: 'date',
        name: 'hireDate',
        label: '入社日',
        hidden: false,
      },
      {
        typ: 'text',
        name: 'planningPeriod',
        label: '該当日or計画期間',
        hidden: false,
      },
      {
        typ: 'text',
        name: 'note',
        label: '備考',
        hidden: false,
      },
      {
        typ: 'text',
        name: 'colorInfo',
        label: '色',
        hidden: true,
      },
    ],
    acceptingEn: true,
    completeStatusList: ['o00800_完了'],
  },
  List: [
    {
      AutoId: 48,
      idx: {
        Value: 0,
      },
      Done: {
        Value: false,
      },
      company: {
        Value: 1,
      },
      stuff: {
        Value: '_none',
      },
      status: {
        Value: 'o00200_【計】提出完了',
      },
      deadline: {
        Value: '2024-06-30',
      },
      startdate: {
        Value: '2024-04-01',
      },
      FlowType: {
        Value: 'subsidy',
      },
      FlowVer: {
        Value: 0,
      },
      Version: {
        Value: 2,
      },
      CreateUserId: {
        Value: 8,
      },
      UpdateUserId: {
        Value: 8,
      },
      DoneUserId: {
        Value: null,
      },
      CreatedAt: {
        Value: '2024-04-18 14:27:06',
      },
      UpdatedAt: {
        Value: '2024-04-18 14:27:34',
      },
      DoneAt: {
        Value: '',
      },
      subsidy: {
        Value: '雇用助成金',
        UpdateUserId: 8,
      },
      filingDate: {
        Value: '2024-04-18',
        UpdateUserId: 8,
      },
      paymentStartDate: {
        Value: '',
        UpdateUserId: 8,
      },
      persons: {
        Value: '',
        UpdateUserId: 8,
      },
      raiseDate: {
        Value: '',
        UpdateUserId: 8,
      },
      hireDate: {
        Value: '',
        UpdateUserId: 8,
      },
      planningPeriod: {
        Value: '',
        UpdateUserId: 8,
      },
      note: {
        Value: '',
        UpdateUserId: 8,
      },
      colorInfo: {
        Value: ';',
        UpdateUserId: 8,
      },
      Egov: null,
      egovStatus: {
        Value: '',
      },
    },
    {
      AutoId: 49,
      idx: {
        Value: 1,
      },
      Done: {
        Value: false,
      },
      company: {
        Value: 1,
      },
      stuff: {
        Value: '_none',
      },
      status: {
        Value: 'o00600_【支】不備対応中',
      },
      deadline: {
        Value: '2024-05-31',
      },
      startdate: {
        Value: '2024-03-06',
      },
      FlowType: {
        Value: 'subsidy',
      },
      FlowVer: {
        Value: 0,
      },
      Version: {
        Value: 3,
      },
      CreateUserId: {
        Value: 8,
      },
      UpdateUserId: {
        Value: 8,
      },
      DoneUserId: {
        Value: null,
      },
      CreatedAt: {
        Value: '2024-04-18 14:28:02',
      },
      UpdatedAt: {
        Value: '2024-04-18 14:29:08',
      },
      DoneAt: {
        Value: '',
      },
      subsidy: {
        Value: '雇用助成金',
        UpdateUserId: 8,
      },
      filingDate: {
        Value: '',
        UpdateUserId: 8,
      },
      paymentStartDate: {
        Value: '',
        UpdateUserId: 8,
      },
      persons: {
        Value: '',
        UpdateUserId: 8,
      },
      raiseDate: {
        Value: '',
        UpdateUserId: 8,
      },
      hireDate: {
        Value: '',
        UpdateUserId: 8,
      },
      planningPeriod: {
        Value: '',
        UpdateUserId: 8,
      },
      note: {
        Value: '',
        UpdateUserId: 8,
      },
      colorInfo: {
        Value: ';',
        UpdateUserId: 8,
      },
      Egov: null,
      egovStatus: {
        Value: '',
      },
    },
    {
      AutoId: 50,
      idx: {
        Value: 2,
      },
      Done: {
        Value: false,
      },
      company: {
        Value: 2,
      },
      stuff: {
        Value: '_none',
      },
      status: {
        Value: 'o00100_【計】作成中',
      },
      deadline: {
        Value: '2024-04-30',
      },
      startdate: {
        Value: '2024-01-17',
      },
      FlowType: {
        Value: 'subsidy',
      },
      FlowVer: {
        Value: 0,
      },
      Version: {
        Value: 1,
      },
      CreateUserId: {
        Value: 8,
      },
      UpdateUserId: {
        Value: 8,
      },
      DoneUserId: {
        Value: null,
      },
      CreatedAt: {
        Value: '2024-04-18 14:28:56',
      },
      UpdatedAt: {
        Value: '2024-04-18 14:28:57',
      },
      DoneAt: {
        Value: '',
      },
      subsidy: {
        Value: 'リスキリング助成金',
        UpdateUserId: 8,
      },
      filingDate: {
        Value: '',
        UpdateUserId: 8,
      },
      paymentStartDate: {
        Value: '',
        UpdateUserId: 8,
      },
      persons: {
        Value: '',
        UpdateUserId: 8,
      },
      raiseDate: {
        Value: '',
        UpdateUserId: 8,
      },
      hireDate: {
        Value: '',
        UpdateUserId: 8,
      },
      planningPeriod: {
        Value: '',
        UpdateUserId: 8,
      },
      note: {
        Value: '',
        UpdateUserId: 8,
      },
      colorInfo: {
        Value: ';',
        UpdateUserId: 8,
      },
      Egov: null,
      egovStatus: {
        Value: '',
      },
    },
    {
      AutoId: 2,
      idx: {
        Value: 3,
      },
      Done: {
        Value: false,
      },
      company: {
        Value: 1,
      },
      stuff: {
        Value: '_none',
      },
      status: {
        Value: 'o00100_【計】作成中',
      },
      deadline: {
        Value: null,
      },
      startdate: {
        Value: '2024-02-01',
      },
      FlowType: {
        Value: 'subsidy',
      },
      FlowVer: {
        Value: 0,
      },
      Version: {
        Value: 2,
      },
      CreateUserId: {
        Value: 4,
      },
      UpdateUserId: {
        Value: 8,
      },
      DoneUserId: {
        Value: null,
      },
      CreatedAt: {
        Value: '2024-03-06 11:42:31',
      },
      UpdatedAt: {
        Value: '2024-04-18 14:27:19',
      },
      DoneAt: {
        Value: '',
      },
      subsidy: {
        Value: 'テスト助成金',
        UpdateUserId: 4,
      },
      filingDate: {
        Value: '',
        UpdateUserId: 4,
      },
      paymentStartDate: {
        Value: '',
        UpdateUserId: 4,
      },
      persons: {
        Value: '',
        UpdateUserId: 4,
      },
      raiseDate: {
        Value: '',
        UpdateUserId: 4,
      },
      hireDate: {
        Value: '',
        UpdateUserId: 4,
      },
      planningPeriod: {
        Value: '',
        UpdateUserId: 4,
      },
      note: {
        Value: '',
        UpdateUserId: 4,
      },
      colorInfo: {
        Value: ';',
        UpdateUserId: 4,
      },
      Egov: null,
      egovStatus: {
        Value: '',
      },
    },
  ],
  Count: 4,
  Type: 'getCheckListsRsp',
}

export const testAgreementCheckList = {
  Value: 'ok',
  Conf: {
    name: 'article36Agreement',
    type: 'checkList',
    title: '36協定',
    columns: [
      {
        lst: [
          {
            label: 'ダミー会社a',
            value: 'ダミー会社a',
          },
          {
            label: 'ダミー会社b',
            value: 'ダミー会社b',
          },
          {
            label: 'ダミー会社c',
            value: 'ダミー会社c',
          },
        ],
        typ: 'select',
        name: 'company',
        label: '会社名',
        hidden: false,
      },
      {
        lst: [
          {
            label: '完了',
            style: {
              'background-color': '#ffffff',
            },
            value: 'o00100_完了',
          },
          {
            label: '申請中',
            style: {
              'background-color': '#ffffff',
            },
            value: 'o00200_申請中',
          },
          {
            label: '確認',
            style: {
              'background-color': '#ff0000',
            },
            value: 'o00300_確認',
          },
          {
            label: '待ち',
            style: {
              'background-color': '#ffffff',
            },
            value: 'o00400_待ち',
          },
        ],
        typ: 'select',
        name: 'status',
        label: '状況',
        hidden: false,
      },
      {
        typ: 'text',
        name: 'special',
        label: '特別条項',
        hidden: false,
      },
      {
        typ: 'date',
        name: 'deadline',
        label: '終了日',
        hidden: false,
      },
      {
        typ: 'text',
        name: 'office',
        label: '監督署',
        hidden: false,
      },
      {
        typ: 'text',
        name: 'note',
        label: '備考',
        hidden: false,
      },
      {
        typ: 'text',
        name: 'colorInfo',
        label: '色',
        hidden: true,
      },
    ],
    acceptingEn: false,
    completeStatusList: ['o00100_完了'],
  },
  List: [
    {
      AutoId: 3,
      idx: {
        Value: 0,
      },
      Done: {
        Value: false,
      },
      company: {
        Value: 1,
      },
      stuff: {
        Value: '_none',
      },
      status: {
        Value: 'o00300_確認',
      },
      deadline: {
        Value: '2024-03-27',
      },
      startdate: {
        Value: null,
      },
      FlowType: {
        Value: 'article36Agreement',
      },
      FlowVer: {
        Value: 0,
      },
      Version: {
        Value: 4,
      },
      CreateUserId: {
        Value: 4,
      },
      UpdateUserId: {
        Value: 6,
      },
      DoneUserId: {
        Value: null,
      },
      CreatedAt: {
        Value: '2024-03-06 11:42:57',
      },
      UpdatedAt: {
        Value: '2024-03-26 15:58:28',
      },
      DoneAt: {
        Value: '',
      },
      special: {
        Value: '有',
        UpdateUserId: 6,
      },
      office: {
        Value: '中央',
        UpdateUserId: 6,
      },
      note: {
        Value: '就業規則（変更）届',
        UpdateUserId: 4,
      },
      colorInfo: {
        Value: ';',
        UpdateUserId: 4,
      },
      Egov: [
        {
          id: 1,
          user_id: 4,
          check_list_id: 3,
          proc_id: '4950013309642000',
          applied_account: null,
          token_sub: '',
          token_email: '',
          arrive_id: '202403061226002992',
          apply_type: '新規申請',
          ministry_name: '厚生労働省',
          apply_form: {
            form: [
              {
                form_name: '就業規則（変更）届【労働基準法第８９条第１項関係】　',
              },
              {
                form_name: '意見書',
              },
            ],
            attached_file: [
              {
                attached_file_name: 'testattachedfile.pdf',
              },
              {
                attached_file_name: '添付書類テスト.pdf',
              },
            ],
          },
          confirm_time: '2024-03-06T12:26:01',
          arrive_date: '2024-03-06T12:26:00',
          status: '到達',
          corporation_name: '株式会社てすと１',
          applicant_name: '橋本　凪',
          proc_name: '就業規則（変更）届　（各事業場単位による届出）／電子申請',
          submission_destination: '千葉労働局,柏労働基準監督署',
          withdraw_flag: true,
          pay_status: '-',
          notice_count: 0,
          doc_count: 0,
          apply_pay_count: 0,
          notice_list: [],
          official_list: [],
          apply_pay_list: [],
          created_at: '2024-03-06T12:26:00',
          updated_at: '2024-03-06T12:26:00',
        },
      ],
      egovStatus: {
        Value: '到達',
      },
    },
    {
      AutoId: 14,
      idx: {
        Value: 1,
      },
      Done: {
        Value: false,
      },
      company: {
        Value: 1,
      },
      stuff: {
        Value: '_none',
      },
      status: {
        Value: 'o00400_待ち',
      },
      deadline: {
        Value: '2024-03-22',
      },
      startdate: {
        Value: null,
      },
      FlowType: {
        Value: 'article36Agreement',
      },
      FlowVer: {
        Value: 0,
      },
      Version: {
        Value: 2,
      },
      CreateUserId: {
        Value: 6,
      },
      UpdateUserId: {
        Value: 6,
      },
      DoneUserId: {
        Value: null,
      },
      CreatedAt: {
        Value: '2024-03-16 15:34:58',
      },
      UpdatedAt: {
        Value: '2024-03-26 16:00:53',
      },
      DoneAt: {
        Value: '',
      },
      special: {
        Value: '',
        UpdateUserId: 6,
      },
      office: {
        Value: '',
        UpdateUserId: 6,
      },
      note: {
        Value: '時間外労働・休日労働に関する協定届（本社一括届）（適用猶予）',
        UpdateUserId: 6,
      },
      colorInfo: {
        Value: ';',
        UpdateUserId: 6,
      },
      Egov: [
        {
          id: 8,
          user_id: 6,
          check_list_id: 14,
          proc_id: '4950013320690000',
          applied_account: null,
          token_sub: '',
          token_email: '',
          arrive_id: '202403161618036572',
          apply_type: '新規申請',
          ministry_name: '厚生労働省',
          apply_form: {
            form: [
              {
                form_name: '時間外労働／休日労働に関する協定届【様式第９号の４（第７０条関係）】',
              },
            ],
            attached_file: [
              {
                attached_file_name: 'test.csv',
              },
            ],
          },
          confirm_time: '2024-03-16T16:18:04',
          arrive_date: '2024-03-16T16:18:03',
          status: '到達',
          corporation_name: '株式会社てすと１',
          applicant_name: '橋本　凪',
          proc_name: '時間外労働・休日労働に関する協定届（本社一括届）（適用猶予）／電子申請',
          submission_destination: '北海道労働局,札幌中央労働基準監督署',
          withdraw_flag: true,
          pay_status: '-',
          notice_count: 0,
          doc_count: 0,
          apply_pay_count: 0,
          notice_list: [],
          official_list: [],
          apply_pay_list: [],
          created_at: '2024-03-16T16:18:04',
          updated_at: '2024-03-16T16:18:04',
        },
      ],
      egovStatus: {
        Value: '到達',
      },
    },
    {
      AutoId: 16,
      idx: {
        Value: 2,
      },
      Done: {
        Value: false,
      },
      company: {
        Value: 1,
      },
      stuff: {
        Value: '_none',
      },
      status: {
        Value: 'o00400_待ち',
      },
      deadline: {
        Value: '2024-03-22',
      },
      startdate: {
        Value: null,
      },
      FlowType: {
        Value: 'article36Agreement',
      },
      FlowVer: {
        Value: 0,
      },
      Version: {
        Value: 4,
      },
      CreateUserId: {
        Value: 6,
      },
      UpdateUserId: {
        Value: 6,
      },
      DoneUserId: {
        Value: null,
      },
      CreatedAt: {
        Value: '2024-03-16 17:18:00',
      },
      UpdatedAt: {
        Value: '2024-03-26 16:01:06',
      },
      DoneAt: {
        Value: '',
      },
      special: {
        Value: '',
        UpdateUserId: 6,
      },
      office: {
        Value: '',
        UpdateUserId: 6,
      },
      note: {
        Value: '時間外労働・休日労働に関する協定届（事業場外労働に関する協定付記）（適用猶予）',
        UpdateUserId: 6,
      },
      colorInfo: {
        Value: ';',
        UpdateUserId: 6,
      },
      Egov: [
        {
          id: 11,
          user_id: 6,
          check_list_id: 16,
          proc_id: '4950013320689000',
          applied_account: null,
          token_sub: '',
          token_email: '',
          arrive_id: '202403161731233962',
          apply_type: '新規申請',
          ministry_name: '厚生労働省',
          apply_form: {
            form: [
              {
                form_name: '時間外労働／休日労働に関する協定届【様式第９号の５（第７０条関係）】',
              },
              {
                form_name: '時間外労働／休日労働に関する協定届（続紙１）',
              },
              {
                form_name: '時間外労働／休日労働に関する協定届（続紙７）',
              },
            ],
            attached_file: null,
          },
          confirm_time: '2024-03-16T17:31:24',
          arrive_date: '2024-03-16T17:31:23',
          status: '到達',
          corporation_name: '株式会社てすと１',
          applicant_name: '橋本　凪',
          proc_name: '時間外労働・休日労働に関する協定届（事業場外労働に関する協定付記）（適用猶予）／電子申請',
          submission_destination: '北海道労働局,札幌中央労働基準監督署',
          withdraw_flag: true,
          pay_status: '-',
          notice_count: 0,
          doc_count: 0,
          apply_pay_count: 0,
          notice_list: [],
          official_list: [],
          apply_pay_list: [],
          created_at: '2024-03-16T17:31:23',
          updated_at: '2024-03-16T17:31:23',
        },
      ],
      egovStatus: {
        Value: '到達',
      },
    },
    {
      AutoId: 13,
      idx: {
        Value: 3,
      },
      Done: {
        Value: false,
      },
      company: {
        Value: 1,
      },
      stuff: {
        Value: '_none',
      },
      status: {
        Value: 'o00400_待ち',
      },
      deadline: {
        Value: '2024-03-21',
      },
      startdate: {
        Value: null,
      },
      FlowType: {
        Value: 'article36Agreement',
      },
      FlowVer: {
        Value: 0,
      },
      Version: {
        Value: 2,
      },
      CreateUserId: {
        Value: 6,
      },
      UpdateUserId: {
        Value: 6,
      },
      DoneUserId: {
        Value: null,
      },
      CreatedAt: {
        Value: '2024-03-16 15:06:31',
      },
      UpdatedAt: {
        Value: '2024-03-26 16:00:47',
      },
      DoneAt: {
        Value: '',
      },
      special: {
        Value: '',
        UpdateUserId: 6,
      },
      office: {
        Value: '',
        UpdateUserId: 6,
      },
      note: {
        Value: '就業規則（変更）届　（各事業場単位による届出）\t',
        UpdateUserId: 6,
      },
      colorInfo: {
        Value: ';',
        UpdateUserId: 6,
      },
      Egov: [
        {
          id: 7,
          user_id: 6,
          check_list_id: 13,
          proc_id: '4950013309642000',
          applied_account: null,
          token_sub: '',
          token_email: '',
          arrive_id: '202403161511303432',
          apply_type: '新規申請',
          ministry_name: '厚生労働省',
          apply_form: {
            form: [
              {
                form_name: '就業規則（変更）届【労働基準法第８９条第１項関係】　',
              },
              {
                form_name: '意見書',
              },
            ],
            attached_file: [
              {
                attached_file_name: '添付書類.txt',
              },
            ],
          },
          confirm_time: '2024-03-16T15:11:31',
          arrive_date: '2024-03-16T15:11:30',
          status: '到達',
          corporation_name: '株式会社てすと１',
          applicant_name: '橋本　凪',
          proc_name: '就業規則（変更）届　（各事業場単位による届出）／電子申請',
          submission_destination: '北海道労働局,札幌中央労働基準監督署',
          withdraw_flag: true,
          pay_status: '-',
          notice_count: 0,
          doc_count: 0,
          apply_pay_count: 0,
          notice_list: [],
          official_list: [],
          apply_pay_list: [],
          created_at: '2024-03-16T15:11:30',
          updated_at: '2024-03-16T15:11:30',
        },
      ],
      egovStatus: {
        Value: '到達',
      },
    },
    {
      AutoId: 4,
      idx: {
        Value: 4,
      },
      Done: {
        Value: false,
      },
      company: {
        Value: 1,
      },
      stuff: {
        Value: '_none',
      },
      status: {
        Value: 'o00400_待ち',
      },
      deadline: {
        Value: '2024-03-20',
      },
      startdate: {
        Value: null,
      },
      FlowType: {
        Value: 'article36Agreement',
      },
      FlowVer: {
        Value: 0,
      },
      Version: {
        Value: 3,
      },
      CreateUserId: {
        Value: 4,
      },
      UpdateUserId: {
        Value: 6,
      },
      DoneUserId: {
        Value: null,
      },
      CreatedAt: {
        Value: '2024-03-06 12:36:08',
      },
      UpdatedAt: {
        Value: '2024-03-26 15:58:54',
      },
      DoneAt: {
        Value: '',
      },
      special: {
        Value: '有',
        UpdateUserId: 6,
      },
      office: {
        Value: '北千住',
        UpdateUserId: 6,
      },
      note: {
        Value: '時間外労働・休日労働に関する協定届（各事業場単位による届出）（一般条項のみ）',
        UpdateUserId: 4,
      },
      colorInfo: {
        Value: ';',
        UpdateUserId: 4,
      },
      Egov: [
        {
          id: 2,
          user_id: 4,
          check_list_id: 4,
          proc_id: '4950013320681000',
          applied_account: null,
          token_sub: '',
          token_email: '',
          arrive_id: '202403061256353512',
          apply_type: '新規申請',
          ministry_name: '厚生労働省',
          apply_form: {
            form: [
              {
                form_name: '時間外労働／休日労働に関する協定届【様式第９号（第１６条第１項関係）】',
              },
            ],
            attached_file: [
              {
                attached_file_name: 'testattachedfile.pdf',
              },
            ],
          },
          confirm_time: '2024-03-06T12:56:36',
          arrive_date: '2024-03-06T12:56:35',
          status: '到達',
          corporation_name: '株式会社てすと１',
          applicant_name: '橋本　凪',
          proc_name: '時間外労働・休日労働に関する協定届（各事業場単位による届出）（一般条項のみ）／電子申請',
          submission_destination: '千葉労働局,柏労働基準監督署',
          withdraw_flag: true,
          pay_status: '-',
          notice_count: 0,
          doc_count: 0,
          apply_pay_count: 0,
          notice_list: [],
          official_list: [],
          apply_pay_list: [],
          created_at: '2024-03-06T12:56:35',
          updated_at: '2024-03-06T12:56:35',
        },
      ],
      egovStatus: {
        Value: '到達',
      },
    },
    {
      AutoId: 12,
      idx: {
        Value: 5,
      },
      Done: {
        Value: false,
      },
      company: {
        Value: 1,
      },
      stuff: {
        Value: '_none',
      },
      status: {
        Value: 'o00100_完了',
      },
      deadline: {
        Value: '2024-03-20',
      },
      startdate: {
        Value: null,
      },
      FlowType: {
        Value: 'article36Agreement',
      },
      FlowVer: {
        Value: 0,
      },
      Version: {
        Value: 3,
      },
      CreateUserId: {
        Value: 6,
      },
      UpdateUserId: {
        Value: 6,
      },
      DoneUserId: {
        Value: null,
      },
      CreatedAt: {
        Value: '2024-03-16 14:53:44',
      },
      UpdatedAt: {
        Value: '2024-03-26 16:00:25',
      },
      DoneAt: {
        Value: '',
      },
      special: {
        Value: '有',
        UpdateUserId: 6,
      },
      office: {
        Value: '渋谷',
        UpdateUserId: 6,
      },
      note: {
        Value: '就業規則（変更）届　（各事業場単位による届出）',
        UpdateUserId: 6,
      },
      colorInfo: {
        Value: ';',
        UpdateUserId: 6,
      },
      Egov: [
        {
          id: 6,
          user_id: 6,
          check_list_id: 12,
          proc_id: '4950013309642000',
          applied_account: null,
          token_sub: '',
          token_email: '',
          arrive_id: '202403161505157552',
          apply_type: '新規申請',
          ministry_name: '厚生労働省',
          apply_form: {
            form: [
              {
                form_name: '就業規則（変更）届【労働基準法第８９条第１項関係】　',
              },
            ],
            attached_file: [
              {
                attached_file_name: '添付書類.txt',
              },
            ],
          },
          confirm_time: '2024-03-16T15:05:16',
          arrive_date: '2024-03-16T15:05:15',
          status: '到達',
          corporation_name: '株式会社てすと１',
          applicant_name: '橋本　凪',
          proc_name: '就業規則（変更）届　（各事業場単位による届出）／電子申請',
          submission_destination: '北海道労働局,札幌中央労働基準監督署',
          withdraw_flag: true,
          pay_status: '-',
          notice_count: 0,
          doc_count: 0,
          apply_pay_count: 0,
          notice_list: [],
          official_list: [],
          apply_pay_list: [],
          created_at: '2024-03-16T15:05:16',
          updated_at: '2024-03-16T15:05:16',
        },
      ],
      egovStatus: {
        Value: '到達',
      },
    },

    {
      AutoId: 40,
      idx: {
        Value: 34,
      },
      Done: {
        Value: false,
      },
      company: {
        Value: 1,
      },
      stuff: {
        Value: '_none',
      },
      status: {
        Value: 'o00200_申請中',
      },
      deadline: {
        Value: null,
      },
      startdate: {
        Value: null,
      },
      FlowType: {
        Value: 'article36Agreement',
      },
      FlowVer: {
        Value: 0,
      },
      Version: {
        Value: 1,
      },
      CreateUserId: {
        Value: 8,
      },
      UpdateUserId: {
        Value: 8,
      },
      DoneUserId: {
        Value: null,
      },
      CreatedAt: {
        Value: '2024-04-12 15:34:45',
      },
      UpdatedAt: {
        Value: '2024-04-12 15:34:46',
      },
      DoneAt: {
        Value: '',
      },
      special: {
        Value: '',
        UpdateUserId: 8,
      },
      office: {
        Value: '',
        UpdateUserId: 8,
      },
      note: {
        Value: '',
        UpdateUserId: 8,
      },
      colorInfo: {
        Value: ';',
        UpdateUserId: 8,
      },
      Egov: null,
      egovStatus: {
        Value: '',
      },
    },
    {
      AutoId: 41,
      idx: {
        Value: 35,
      },
      Done: {
        Value: false,
      },
      company: {
        Value: 1,
      },
      stuff: {
        Value: '_none',
      },
      status: {
        Value: '',
      },
      deadline: {
        Value: null,
      },
      startdate: {
        Value: null,
      },
      FlowType: {
        Value: 'article36Agreement',
      },
      FlowVer: {
        Value: 0,
      },
      Version: {
        Value: 1,
      },
      CreateUserId: {
        Value: 6,
      },
      UpdateUserId: {
        Value: 6,
      },
      DoneUserId: {
        Value: null,
      },
      CreatedAt: {
        Value: '2024-04-14 09:58:46',
      },
      UpdatedAt: {
        Value: '2024-04-14 09:58:47',
      },
      DoneAt: {
        Value: '',
      },
      special: {
        Value: '',
        UpdateUserId: 6,
      },
      office: {
        Value: '',
        UpdateUserId: 6,
      },
      note: {
        Value: '',
        UpdateUserId: 6,
      },
      colorInfo: {
        Value: ';',
        UpdateUserId: 6,
      },
      Egov: null,
      egovStatus: {
        Value: '',
      },
    },
  ],
  Count: 36,
  Type: 'getCheckListsRsp',
}

export const testEgov = {}

export const testEgovList = {}

export const testUsers = [
  {
    AutoId: 2,
    Uid: 'spiadmin',
    Name: 'システム管理者',
    NameKana: 'システムカンリシャ',
    ShortName: 'spiadmin',
    MailAddress: 'admin@example.com',
    OldPass: 'oldpass123',
    Passwd: 'hashedPassword123',
    Organization: 1,
    UserTyp: 'admin',
    Department: 'システム管理部',
    DepartmentKana: 'システムカンリブ',
    Title: '管理者',
    PhoneNumber: '03-1234-5678',
    FaxNumber: '03-1234-5679',
    NoticeMailCondition: 'all',
    OtpEnable: true,
    Passkeys: [
      {
        aid: 1,
        bid: 'A1qMTlEzthZXIowPGTuDRbt7gfmqPxmldOPDzKLsBF0=',
        signCount: 5,
        transportsText: 'usb,ble',
        info: 'Windows 11 PC',
        createdAt: '2024-01-01T10:00:00',
        updatedAt: '2024-01-01T10:00:00',
      },
    ],
    PasswdDisable: false,
    LoginFailureLockEnable: true,
    IsLocked: false,
    TodoListCreatePerDay: 50,
    InitPasswdChanged: true,
    CompanyCreatePerDay: 10,
    IsActive: true,
  },
  {
    AutoId: 9,
    Uid: 'd-takahashi',
    Name: '高橋 大輔',
    NameKana: 'タカハシ ダイスケ',
    ShortName: '高橋',
    MailAddress: 'd-takahashi@example.com',
    OldPass: 'takahashi123',
    Passwd: 'hashedPassword456',
    Organization: 1,
    UserTyp: 'manager',
    Department: '営業部',
    DepartmentKana: 'エイギョウブ',
    Title: '部長',
    PhoneNumber: '03-2345-6789',
    FaxNumber: '03-2345-6780',
    NoticeMailCondition: 'important',
    OtpEnable: true,
    Passkeys: [
      {
        aid: 2,
        bid: 'B2qMTlEzthZXIowPGTuDRbt7gfmqPxmldOPDzKLsBF0=',
        signCount: 3,
        transportsText: 'usb',
        info: 'MacBook Pro',
        createdAt: '2024-02-15T14:30:00',
        updatedAt: '2024-02-15T14:30:00',
      },
    ],
    PasswdDisable: false,
    LoginFailureLockEnable: true,
    IsLocked: false,
    TodoListCreatePerDay: 20,
    InitPasswdChanged: true,
    CompanyCreatePerDay: 5,
    IsActive: true,
  },
  {
    AutoId: 10,
    Uid: 'kainuma2',
    Name: '貝沼 誠',
    NameKana: 'カイヌマ マコト',
    ShortName: '貝沼',
    MailAddress: 'kainuma2@example.com',
    OldPass: 'kainuma123',
    Passwd: 'hashedPassword789',
    Organization: 1,
    UserTyp: 'user',
    Department: '開発部',
    DepartmentKana: 'カイハツブ',
    Title: '主任',
    PhoneNumber: '03-3456-7890',
    FaxNumber: '03-3456-7891',
    NoticeMailCondition: 'medium',
    OtpEnable: false,
    Passkeys: [],
    PasswdDisable: false,
    LoginFailureLockEnable: true,
    IsLocked: false,
    TodoListCreatePerDay: 15,
    InitPasswdChanged: true,
    CompanyCreatePerDay: 0,
    IsActive: true,
  },
  {
    AutoId: 11,
    Uid: 'test',
    Name: 'テストユーザー',
    NameKana: 'テストユーザー',
    ShortName: 'test',
    MailAddress: 'test@example.com',
    OldPass: 'test123',
    Passwd: 'hashedPasswordABC',
    Organization: 1,
    UserTyp: 'user',
    Department: 'テスト部門',
    DepartmentKana: 'テストブモン',
    Title: 'テスター',
    PhoneNumber: '03-4567-8901',
    FaxNumber: '03-4567-8902',
    NoticeMailCondition: 'none',
    OtpEnable: false,
    Passkeys: [],
    PasswdDisable: true,
    LoginFailureLockEnable: true,
    IsLocked: true,
    TodoListCreatePerDay: 0,
    InitPasswdChanged: false,
    CompanyCreatePerDay: 0,
    IsActive: false,
  },
  {
    AutoId: 12,
    Uid: 'TestUser',
    Name: 'テスト　ユーザー',
    NameKana: 'テスト ユーザー',
    ShortName: 'テスト',
    MailAddress: 'testuser@example.com',
    OldPass: 'testuser123',
    Passwd: 'hashedPasswordDEF',
    Organization: 1,
    UserTyp: 'user',
    Department: '品質管理部',
    DepartmentKana: 'ヒンシツカンリブ',
    Title: '担当',
    PhoneNumber: '03-5678-9012',
    FaxNumber: '03-5678-9013',
    NoticeMailCondition: 'low',
    OtpEnable: false,
    Passkeys: [],
    PasswdDisable: false,
    LoginFailureLockEnable: true,
    IsLocked: false,
    TodoListCreatePerDay: 10,
    InitPasswdChanged: true,
    CompanyCreatePerDay: 0,
    IsActive: true,
  },
]

export const testPosts = [
  {
    AutoId: 1,
    ViewStart: '2024-01-01',
    ViewEnd: '2024-12-31',
    Title: 'お知らせ１',
    Text: 'お知らせ１の内容',
    OrgId: 1,
    UserId: 2,
    PostedOn: '2024-01-01',
    idx: 1,
  },
  {
    AutoId: 2,
    ViewStart: '2024-01-01',
    ViewEnd: '2024-12-31',
    Title: 'お知らせ２',
    Text: 'お知らせ２の内容',
    OrgId: 1,
    UserId: 2,
    PostedOn: '2024-01-01',
    idx: 2,
  },
  {
    AutoId: 3,
    ViewStart: '2024-01-01',
    ViewEnd: '2024-12-31',
    Title: 'お知らせ３',
    Text: 'お知らせ３の内容',
    OrgId: 1,
    UserId: 2,
    PostedOn: '2024-01-01',
    idx: 3,
  },
]

export const testOffice = {}

// testdata.jsファイルの末尾に以下を追加

export const testEGovProcList = {
  Value: 'ok',
  Dic: {
    article36: {
      手続ID: '0000000001_001',
      手続名: '時間外労働・休日労働に関する協定届',
      行政機関: '厚生労働省',
    },
  },
}

export const testPublicProcedureInfo = `<?xml version="1.0" encoding="UTF-8"?>
<AdminProcInfo>
  <AdminProcID>0000000001</AdminProcID>
  <AdminProcName>時間外労働・休日労働に関する協定届</AdminProcName>
  <ProcInfo>
    <ProcID>0000000001_001</ProcID>
    <ProcName>時間外労働・休日労働に関する協定届</ProcName>
    <AttachedFileInfo>
      <AttachedFileName>就業規則</AttachedFileName>
    </AttachedFileInfo>
    <AttachedFileInfo>
      <AttachedFileName>労働者代表選出証明書</AttachedFileName>
    </AttachedFileInfo>
    <FormInfo>
      <FormId>FORM001</FormId>
      <FormName>36協定届（一般条項）</FormName>
      <FormVersion>1</FormVersion>
      <XMLFile>form001.xml</XMLFile>
      <XSLFile>form001.xsl</XSLFile>
      <ServerCheckFile>form001_check.xml</ServerCheckFile>
    </FormInfo>
    <FormInfo>
      <FormId>FORM002</FormId>
      <FormName>36協定届（特別条項）</FormName>
      <FormVersion>1</FormVersion>
      <XMLFile>form002.xml</XMLFile>
      <XSLFile>form002.xsl</XSLFile>
      <ServerCheckFile>form002_check.xml</ServerCheckFile>
    </FormInfo>
    <OrgInfo>
      <OrgId>001</OrgId>
      <OrgName>○○労働基準監督署</OrgName>
    </OrgInfo>
  </ProcInfo>
</AdminProcInfo>`

export const testKouseiXml = `<?xml version="1.0" encoding="UTF-8"?>
<DataRoot>
  <STYLESHEET>kousei.xsl</STYLESHEET>
  <構成情報>
    <管理情報>
      <手続番号>
        <受付行政機関ID>100495</受付行政機関ID>
        <手続ID></手続ID>
      </手続番号>
      <手続名称></手続名称>
      <申請種別></申請種別>
      <申請者連絡先情報>
        <申請者情報>
          <氏名></氏名>
          <氏名フリガナ></氏名フリガナ>
          <役職></役職>
          <法人団体名></法人団体名>
          <法人団体名フリガナ></法人団体名フリガナ>
          <部門名></部門名>
          <部門名フリガナ></部門名フリガナ>
          <郵便番号></郵便番号>
          <住所></住所>
          <住所フリガナ></住所フリガナ>
          <電話番号></電話番号>
          <FAX番号></FAX番号>
          <電子メールアドレス></電子メールアドレス>
        </申請者情報>
        <連絡先情報>
          <氏名></氏名>
          <氏名フリガナ></氏名フリガナ>
          <役職></役職>
          <法人団体名></法人団体名>
          <法人団体名フリガナ></法人団体名フリガナ>
          <部門名></部門名>
          <部門名フリガナ></部門名フリガナ>
          <郵便番号></郵便番号>
          <住所></住所>
          <住所フリガナ></住所フリガナ>
          <電話番号></電話番号>
          <FAX番号></FAX番号>
          <電子メールアドレス></電子メールアドレス>
        </連絡先情報>
      </申請者連絡先情報>
    </管理情報>
    <提出先情報>
      <提出先名称></提出先名称>
      <提出先識別子></提出先識別子>
    </提出先情報>
  </構成情報>
  <その他>
    <法人番号></法人番号>
  </その他>
</DataRoot>`

export const testFormXml = `<?xml version="1.0" encoding="UTF-8"?>
<DataRoot>
  <STYLESHEET>form001.xsl</STYLESHEET>
  <様式ID>FORM001</様式ID>
  <様式バージョン>1</様式バージョン>
  <申請書データ>
    <事業場名称></事業場名称>
    <事業場所在地></事業場所在地>
    <労働者数></労働者数>
    <協定開始日></協定開始日>
    <協定終了日></協定終了日>
    <時間外労働上限></時間外労働上限>
  </申請書データ>
</DataRoot>`

export const testXslFile = `<?xml version="1.0" encoding="UTF-8"?>
<xsl:stylesheet version="1.0" xmlns:xsl="http://www.w3.org/1999/XSL/Transform">
<xsl:output method="html" encoding="UTF-8"/>
<xsl:template match="/">
<form style="width: 800px; height: 1200px; position: relative; background: white; border: 1px solid #ccc;">
  <div style="width: 800px; height: 1200px; position: relative;">
    <span style="position: absolute; left: 50px; top: 50px; font-weight: bold; font-size: 18px;">時間外労働・休日労働に関する協定届</span>
    
    <span style="position: absolute; left: 50px; top: 100px;">事業場名称：</span>
    <xsl:choose>
      <xsl:when test="DataRoot/申請書データ/事業場名称">
        <span style="position: absolute; left: 150px; top: 100px; border-bottom: 1px solid #000; width: 300px; height: 20px;">
          <xsl:value-of select="DataRoot/申請書データ/事業場名称"/>
        </span>
      </xsl:when>
      <xsl:otherwise>
        <input style="position: absolute; left: 150px; top: 100px; width: 300px;" type="text" name="申請書データ/事業場名称"/>
      </xsl:otherwise>
    </xsl:choose>
    
    <span style="position: absolute; left: 50px; top: 140px;">事業場所在地：</span>
    <xsl:choose>
      <xsl:when test="DataRoot/申請書データ/事業場所在地">
        <span style="position: absolute; left: 150px; top: 140px; border-bottom: 1px solid #000; width: 400px; height: 20px;">
          <xsl:value-of select="DataRoot/申請書データ/事業場所在地"/>
        </span>
      </xsl:when>
      <xsl:otherwise>
        <input style="position: absolute; left: 150px; top: 140px; width: 400px;" type="text" name="申請書データ/事業場所在地"/>
      </xsl:otherwise>
    </xsl:choose>
    
    <span style="position: absolute; left: 50px; top: 180px;">労働者数：</span>
    <xsl:choose>
      <xsl:when test="DataRoot/申請書データ/労働者数">
        <span style="position: absolute; left: 150px; top: 180px; border-bottom: 1px solid #000; width: 100px; height: 20px;">
          <xsl:value-of select="DataRoot/申請書データ/労働者数"/>
        </span>
      </xsl:when>
      <xsl:otherwise>
        <input style="position: absolute; left: 150px; top: 180px; width: 100px;" type="text" name="申請書データ/労働者数"/>
      </xsl:otherwise>
    </xsl:choose>
    
    <span style="position: absolute; left: 50px; top: 220px;">協定期間：</span>
    <xsl:choose>
      <xsl:when test="DataRoot/申請書データ/協定開始日">
        <span style="position: absolute; left: 150px; top: 220px; border-bottom: 1px solid #000; width: 150px; height: 20px;">
          <xsl:value-of select="DataRoot/申請書データ/協定開始日"/>
        </span>
      </xsl:when>
      <xsl:otherwise>
        <input style="position: absolute; left: 150px; top: 220px; width: 150px;" type="text" name="申請書データ/協定開始日"/>
      </xsl:otherwise>
    </xsl:choose>
    
    <span style="position: absolute; left: 320px; top: 220px;">〜</span>
    
    <xsl:choose>
      <xsl:when test="DataRoot/申請書データ/協定終了日">
        <span style="position: absolute; left: 350px; top: 220px; border-bottom: 1px solid #000; width: 150px; height: 20px;">
          <xsl:value-of select="DataRoot/申請書データ/協定終了日"/>
        </span>
      </xsl:when>
      <xsl:otherwise>
        <input style="position: absolute; left: 350px; top: 220px; width: 150px;" type="text" name="申請書データ/協定終了日"/>
      </xsl:otherwise>
    </xsl:choose>
    
    <span style="position: absolute; left: 50px; top: 260px;">時間外労働の上限：</span>
    <xsl:choose>
      <xsl:when test="DataRoot/申請書データ/時間外労働上限">
        <span style="position: absolute; left: 200px; top: 260px; border-bottom: 1px solid #000; width: 100px; height: 20px;">
          <xsl:value-of select="DataRoot/申請書データ/時間外労働上限"/>
        </span>
      </xsl:when>
      <xsl:otherwise>
        <input style="position: absolute; left: 200px; top: 260px; width: 100px;" type="text" name="申請書データ/時間外労働上限"/>
      </xsl:otherwise>
    </xsl:choose>
    <span style="position: absolute; left: 320px; top: 260px;">時間/月</span>
  </div>
</form>
</xsl:template>
</xsl:stylesheet>`

export const testServerCheckFile = `<?xml version="1.0" encoding="UTF-8"?>
<checkRoot>
  <checkItem>
    <errtag>申請書データ/事業場名称</errtag>
    <xpath>申請書データ/事業場名称</xpath>
    <inputCheck>
      <omitDisabled/>
      <inputData>
        <specifiedLetter>
          <value>全角文字</value>
        </specifiedLetter>
        <range>
          <within>
            <value>50</value>
          </within>
        </range>
      </inputData>
    </inputCheck>
  </checkItem>
  <checkItem>
    <errtag>申請書データ/労働者数</errtag>
    <xpath>申請書データ/労働者数</xpath>
    <inputCheck>
      <omitDisabled/>
      <numerical>
        <range>
          <within>
            <value>10</value>
          </within>
        </range>
      </numerical>
    </inputCheck>
  </checkItem>
</checkRoot>`
